import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Toast,
} from "react-bootstrap";
import {
  faCaretDown,
  faCaretUp,
  faEye,
  faPen,
  faPenToSquare,
  faPrint,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcons } from "@dcam/dcam_flhealth_component_library";
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  useRef,
} from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { apiConfig } from "../../authConfig";
import apiClient from "../../client/ApiGetClient";
import useData from "../../hooks/useData";
import usePostData from "../../hooks/usePostData";

import { toast } from "react-toastify";
// @ts-ignore: allow importing CSS side-effect
import "react-toastify/dist/ReactToastify.css";
import { Console } from "console";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import {
  CaseReportFormRequest,
  ClientSearchResult,
  ClientUpdateRequest,
  DiagnosisDetail,
  HistoricalTestRow,
  SearchInfoRequest,
  SearchLabRequest,
  SelectOption,
} from "../../types";

import usePost from "../../hooks/usePost";
import useGetData from "../../hooks/useGetData";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
import "./ProviderDashboard.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { providerDashboardSchema, TestingInformationValidation } from "./validation";
import { RoleData, UserDetails } from "../Dashboard/Dashboard.types";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import { adjustDateToMax, adjustDateToMin } from "../../helpers/dateHelper";
import { useNavigate } from "react-router-dom";

export interface EditCaseRequest {
  clientId: number;
  caseReportId?: number;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  dob?: string;
  street1?: string;
  street2?: string;
  birthGenderName?: string;
  city?: string;
  stateName?: string;
  countyName?: string;
  zipCode?: string;
  ssn?: string | null;
  primaryPhone?: number;
  secondPhone?: number;
  comments?: string;
  erContactName?: string;
  erContactRelation?: string;
  erContactPhone?: string;
  relationshipId?: number,
  relationshipName?: string,
  routinizedHospitalName: string;
  routinizedFacilityName: string;
  chiefComplaint?: string;
  symptoms?: string;
  datePresented?: string;
  dateDischarged?: string;
  medicalRecord?: string;
  dateReceived?: string;
  dateTest?: string;
  rprTest?: string;
  tppaTest?: string;
  ftaAbsTest?: string;
  _200Test?: string;
  _300Test?: string;
  treatment?: string;
  naat?: string;
  hivAgAb?: string;
  hivIa?: string;
  disclosed?: string;
  inCare?: string;
  isSelfReported?: boolean;
  isCaseReport?: boolean;
  isPositiveTest?: boolean;
  medication?: string;
  dateLabs?: string;
  pregnantId?: string;
  edd?: string;
  dateLmp?: string;
  additionalNotes?: string;
  dohNotes?: string;
  hospitalAdmit?: boolean;
  hospitalLocation: string;
  hospitalRoom: string;
  modeofTransmission: string;
  viralLoad?: string;
  cd4count?: string;

  naatdate?: string;
  hivAgAbDate?: string;
  hivIaDate?: string;
  inCareDate?: string;
  disclosedDate?: string;
  linkageCareStatusId?: string;
  linkageCareStatusOtherDetails?: string;

  updatedBy?: string;
  addressTypeDetailNewCase: string;
  rpR_Specimen_Collection_Date: string;
  rpR_Specimen_ID: string;
  rpR_Details: string;
  rpR_Titer: string;
  vdrL_Specimen_Collection_Date: string;
  vdrL_Specimen_ID: string;
  vdrL_Details: string;
  vdrL_Titer: string;
  tppA_Specimen_Collection_Date: string;
  tppA_Specimen_ID: string;
  tppA_Details: string;
  ftA_ABS_Specimen_Collection_Date: string;
  ftA_ABS_Specimen_ID: string;
  ftA_ABS_Details: string;
  EIA_IgG_Specimen_Collection_Date: string;
  EIA_IgG_Specimen_ID: string;
  EIA_IgG_Details: string;
  chlamydiaDate: string;
  chlamydia_Specimen_ID: string;
  chlamydia_Details: string;
  gonorrhea_Specimen_Collection_Date: string;
  gonorrhea_Specimen_ID: string;
  gonorrhea_Details: string;
  last_viral_load_date: string;
  last_cd4_count_date: string;
  linkageToCareStatusForHivDiagnosis: string;

  updatedEditable: string;
  updatedLinkageToCareStatusForHivDiagnosis: string;

  updatedHivdateofDiagnosis: string;
  updatedViralLoad: string;
  updatedCd4count: string;
  updatedlast_cd4_count_date: string;
  updatedlast_viral_load_date: string;

  aidsDate: string;
  hivReportedDate: string;
  hivmodeOfTransmissionId: string;
  updatedAidsDate: string;
  updatedHivReportedDate: string;
  updatedHivmodeOfTransmissionId: string;

  //Updated STD info 
  UpdatedRprType?: string,
  UpdatedRprSpecimenCollectionDate?: string,
  UpdatedRprSpecimenId?: string,
  UpdatedRprDetails?: string,
  UpdatedRprTiter?: string,

  UpdatedVdrlType?: string,
  UpdatedVdrlSpecimenCollectionDate?: string,
  UpdatedVdrlSpecimenId?: string,
  UpdatedVdrlDetails?: string,
  UpdatedVdrlTiter?: string,

  UpdatedTpPaType?: string,
  UpdatedTpPaSpecimenCollectionDate?: string,
  UpdatedTpPaSpecimenId?: string,
  UpdatedTpPaDetails?: string,
  UpdatedTpPaTiter?: string,

  UpdatedFtaAbsType?: string,
  UpdatedFtaAbsSpecimenCollectionDate?: string,
  UpdatedFtaAbsSpecimenId?: string,
  UpdatedFtaAbsDetails?: string,
  UpdatedFtaAbsTiter?: string,

  updatedEIAType?: string;
  updatedEIADate?: string;
  updatedEIASpecimenId?: string;
  updatedEIADetails?: string;
  updatedEIATiter?: string;

  UpdatedChlamydiaType?: string,
  UpdatedChlamydiaDate?: string,
  UpdatedChlamydiaSpecimenId?: string,
  UpdatedChlamydiaDetails?: string,
  UpdatedChlamydiaTiter?: string,

  UpdatedGonorrheaType?: string,
  UpdatedGonorrheaSpecimenCollectionDate?: string,
  UpdatedGonorrheaSpecimenId?: string,
  UpdatedGonorrheaDetails?: string,
  UpdatedGonorrheaTiter?: string,

  rPR_Type: string,
  rPR_Result: string,
  vDRL_Type: string,
  vDRL_Result: string,
  tPPA_Type: string,
  tPPA_Result: string,
  fTAABS_Type: string,
  fTAABS_Result: string,
  eIAIgG_Type: string,
  eIAIgG_Result: string,
  chlamydia_Type: string,
  chlamydia_Result: string,
  gonorrhea_Type: string,
  gonorrhea_Result: string,

  updatedRPR_Type: string,
  updatedRPR_Result: string,
  updatedVDRL_Type: string,
  updatedVDRL_Result: string,
  updatedTPPA_Type: string,
  updatedTPPA_Result: string,
  updatedFTAABS_Type: string,
  updatedFTAABS_Result: string,
  updatedEIA_Type: string,
  updatedEIA_Result: string,
  updatedChlamydia_Type: string,
  updatedChlamydia_Result: string,
  updatedGonorrhea_Type: string,
  updatedGonorrhea_Result: string,

}

type SyphilisTreatmentHistoryRow = {
  source?: string | null;
  providerName?: string | null;
  starsAddedDate?: string | null;
  screeningDate?: string | null;
  examDate?: string | null;
  treatedDate?: string | null;
  treatmentData?: string | null;
  treatmentHistoryRowNum?: number | null;
  treatmentAdministeredName?: string | null;
};

type StdTestInformationRow = {
  specimenDate?: string | null;
  specimenId?: string | null;
  details?: string | null;
  titer?: string | null;
  historyNumber?: number | null;
};

type StdTestInformationGroup = {
  testName: string;
  rows: StdTestInformationRow[];
};



const minDate: string = new Date('1850-01-01')?.toISOString()?.split('T')[0];

const ProviderDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [clientInfoValidationErrors, setclientInfoValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const account = accounts[0];
  const [roleName, setRoleName] = useState<string>("");
  const [selectedClient, setSelectedClient] = useState<any>(null); // Track selected client
  const [showTestingInformationError, setShowTestingInformationError] = useState(true);
  const isCaseReportRef = useRef(false);
  const isPositiveTestRef = useRef({
    naat: true,
    disclosed: true,
    hivagab: true,
    incare: true,
    hivIa: true
  });
  const [showEditForm, setShowEditForm] = useState<boolean>(false);
  const editSectionRef = useRef<HTMLDivElement>(null);
  const [allRoutinizedHospitalsData, setAllRoutinizedHospitalsData] = useState<
    SelectOption[]
  >([]);
  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] =
    useState<SelectOption[]>([]);
  const [selectedHospitalId, setSelectedHospitalId] = useState<number | null>(
    null
  );
  const [selectedFacilityId, setSelectedFacilityId] = useState<number | null>(
    null
  );
  const [states, setStates] = useState<SelectOption[]>([]);
  const [counties, setCounties] = useState<SelectOption[]>([]);
  const [highlightedClientId, setHighlightedClientId] = useState<number | null>(
    null
  );
  const [relationshipTypes, setRelationshipTypes] = useState<SelectOption[]>([]);

  const [linkageCareStatus, setLinkageCareStatus] = useState<string>("");
  const [addressType, setAddressType] = useState("");
  const [isAddressRequired, setIsAddressRequired] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [allLinkageCareStatusesData, setallLinkageCareStatusesData] = useState<
    SelectOption[]
  >([]);

  const [allModeoftransmissionData, setallModeoftransmissionData] = useState<
    SelectOption[]
  >([]);

  const { getDataById: getModeofTransmission } = useGetData<
    RoleData[],
    string
  >("Client/ModeOfTransmissions", "GET");

  const toggleRef = useRef<HTMLButtonElement | null>(null);
  // useEffect(() => {
  //   const updateTogglePosition = () => {
  //     const nav = document.getElementById('provider-sticky-nav') as HTMLElement | null;
  //     if (!nav || !toggleRef.current) return;
  //     const navRightOffset = 20; // matches .sticky-nav { right: 20px; }
  //     const gap = 8;             // gap between nav and toggle
  //     const offset = navRightOffset + nav.offsetWidth + gap;
  //     toggleRef.current.style.right = `${offset}px`;
  //     toggleRef.current.style.top = `305px`; // keep your vertical position
  //   };

  //   updateTogglePosition();
  //   window.addEventListener('resize', updateTogglePosition);
  //   return () => window.removeEventListener('resize', updateTogglePosition);
  // }, []);

  // Floating nav state + responsive width
  const [isNavCollapsed, setIsNavCollapsed] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);
  const focusRef = useRef<HTMLDivElement | null>(null);
  const updateTogglePosition = () => {
    const toggle = toggleRef.current;
    const nav = document.getElementById('provider-sticky-nav') as HTMLElement | null;
    if (!toggle) return;

    // Helper: center in viewport
    const centerInViewport = () => {
      const topViewport = (window.innerHeight - toggle.offsetHeight) / 2 + window.scrollY;
      toggle.style.top = `${Math.max(8, Math.round(topViewport))}px`;
    };

    // Collapsed: pin to extreme right and center in viewport
    if (isNavCollapsed) {
      toggle.style.right = '20px';
      centerInViewport();
      toggle.classList.add('provider-nav-toggle--collapsed');
      toggle.classList.remove('provider-nav-toggle--expanded');
      return;
    }

    // Expanded: if nav exists, compute position; otherwise fallback to viewport center
    if (nav) {
      const navRect = nav.getBoundingClientRect();
      const navTopViewport = navRect.top; // relative to viewport
      const navBottomViewport = navRect.bottom;
      const navHeight = navRect.height || nav.offsetHeight;

      // If nav is mostly offscreen (top < 0 or bottom < 0 or top > viewport), center in viewport
      const navVisible = navBottomViewport > 8 && navTopViewport < window.innerHeight - 8;

      const navRightOffset = 20; // same as .sticky-nav { right: 20px; }
      const gap = 8;
      const offset = navRightOffset + nav.offsetWidth + gap;

      toggle.style.right = `${Math.round(offset)}px`;

      if (navVisible) {
        // center relative to nav (use page coordinates)
        const navTopPage = navRect.top + window.scrollY;
        const top = navTopPage + (navHeight / 2) - (toggle.offsetHeight / 2);
        toggle.style.top = `${Math.max(8, Math.round(top))}px`;
      } else {
        // nav offscreen: center in viewport so toggle stays visible
        centerInViewport();
      }

      toggle.classList.remove('provider-nav-toggle--collapsed');
      toggle.classList.add('provider-nav-toggle--expanded');
    } else {
      // no nav element: fallback to CSS or center in viewport
      toggle.style.right = '';
      centerInViewport();
      toggle.classList.remove('provider-nav-toggle--collapsed');
      toggle.classList.add('provider-nav-toggle--expanded');
    }
  };



  // Toggle nav collapse
  const handleNavToggle = () => {
    setIsNavCollapsed(prev => !prev);
  };

  // Keep window width updated
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
      // move focus for accessibility
      element.setAttribute("tabindex", "-1");
      (element as HTMLElement).focus();
    }
  };

  const handleNavItemClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();

    // Expand the matching provider collapse state so the section is visible
    switch (id) {
      case 'MedicalInformation':
        setIsMedicalCollapsed(false);
        break;
      case 'TestingInformation':
        setIsTestingInfoCollapsed(false);
        break;
      case 'HIVDetails':
        setIsHivCollapsed(false);
        break;
      case 'UpdatedHIVDetails':
        setIsUpdatedHivCollapsed(false);
        break;
      case 'STDTestInformation':
        setIsStdCollapsed(false);
        break;
      case 'SyphilisTreatmentInformation':
        setIsSyphilisTreatmentCollapsed(false);
        break;
      case 'UpdatedSTDTestInformation':
        setIsUpdatedStdCollapsed(false);
        break;
      case 'PregnancyInformation':
        // if you have a pregnancy collapse state, open it here
        break;
      default:
        break;
    }

    handleScrollToSection(id);
  };


  const [clientData, setClientData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [maxDate, setMaxDate] = useState("");

  const convertToISODate = (dateStr: string | null) => {
    if (!dateStr) return "";
    const parts = dateStr.split("/");
    if (parts.length !== 3) return "";
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

const formatDisplayDate = (dateStr?: string | null) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US");
};

const formatStdTableDate = (dateStr?: string | null) => {
  if (!dateStr) return "";

  const datePart = dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
  const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${month}/${day}/${year}`;
  }

  const slashMatch = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const [, month, day, year] = slashMatch;
    return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
  }

  return dateStr;
};

const hasHivData =
  Boolean(selectedClient?.hivdateofDiagnosis) ||
  Boolean(selectedClient?.last_cd4_count_date) ||
  Boolean(selectedClient?.last_viral_load_date) ||
  Boolean(selectedClient?.aidsDate) ||
  Boolean(selectedClient?.hivReportedDate);
// 2. Collapse state
const [isHivCollapsed, setIsHivCollapsed] = useState(true);

  // 3. Auto-expand when data exists
  useEffect(() => {
    if (hasHivData) {
      setIsHivCollapsed(false);
    } else {
      setIsHivCollapsed(true);
    }
  }, [hasHivData]);

  // 4. Toggle
  const toggleHiv = () => {
    setIsHivCollapsed(prev => !prev);
  };

  // 1. Check if ANY field has data
  const hasUpdatedHivData =
    Boolean(selectedClient?.updatedHIVDateofDiagnosis) ||
    Boolean(selectedClient?.updatedlast_cd4_count_date) ||
    Boolean(selectedClient?.updatedlast_viral_load_date) ||
    Boolean(selectedClient?.updatedAidsDate) ||
    Boolean(selectedClient?.updatedHivReportedDate);
  // 2. Collapse state
  const [isUpdatedHivCollapsed, setIsUpdatedHivCollapsed] = useState(true);

  // 3. Auto-expand when data exists
  useEffect(() => {
    if (hasUpdatedHivData) {
      setIsUpdatedHivCollapsed(false);
    } else {
      setIsUpdatedHivCollapsed(true);
    }
  }, [hasUpdatedHivData]);

  // 4. Toggle
  const toggleUpdatedHiv = () => {
    setIsUpdatedHivCollapsed(prev => !prev);
  };

  // 1. Check if ANY field has data
  const hasUpdatedStdData =
    Boolean(selectedClient?.updatedChlamydiaDate) ||
    Boolean(selectedClient?.updatedEIADate) ||
    Boolean(selectedClient?.updatedFtaAbsSpecimenCollectionDate) ||
    Boolean(selectedClient?.updatedGonorrheaSpecimenCollectionDate) ||
    Boolean(selectedClient?.updatedTpPaSpecimenCollectionDate) ||
    Boolean(selectedClient?.updatedVdrlSpecimenCollectionDate) ||
    Boolean(selectedClient?.updatedRprSpecimenCollectionDate);
  // 2. Collapse state
  const [isUpdatedStdCollapsed, setIsUpdatedStdCollapsed] = useState(true);

  // 3. Auto-expand when data exists
  useEffect(() => {
    if (hasUpdatedStdData) {
      setIsUpdatedStdCollapsed(false);
    } else {
      setIsUpdatedStdCollapsed(true);
    }
  }, [hasUpdatedStdData]);

  // 4. Toggle
  const toggleUpdatedStd = () => {
    setIsUpdatedStdCollapsed(prev => !prev);
  };
  const hasStdData =
    Boolean(selectedClient?.gonorrhea_Specimen_Collection_Date) ||
    Boolean(selectedClient?.eiA_IgG_Specimen_Collection_Date) ||
    Boolean(selectedClient?.ftA_ABS_Specimen_Collection_Date) ||
    Boolean(selectedClient?.tppA_Specimen_Collection_Date) ||
    Boolean(selectedClient?.vdrL_Specimen_Collection_Date) ||
    Boolean(selectedClient?.rpR_Specimen_Collection_Date);

  const [isStdCollapsed, setIsStdCollapsed] = useState(true);

  useEffect(() => {
    if (hasStdData) {
      setIsStdCollapsed(false);   // expand
    } else {
      setIsStdCollapsed(true);    // collapse
    }
  }, [
    hasStdData
  ]);

  const toggleStd = () => {
    setIsStdCollapsed(prev => !prev);
  };

  const [syphilisTreatmentHistory, setSyphilisTreatmentHistory] = useState<SyphilisTreatmentHistoryRow[]>([]);
  const hasSyphilisTreatmentData = syphilisTreatmentHistory.length > 0;
  const [isSyphilisTreatmentCollapsed, setIsSyphilisTreatmentCollapsed] = useState(true);

  useEffect(() => {
    setIsSyphilisTreatmentCollapsed(!hasSyphilisTreatmentData);
  }, [hasSyphilisTreatmentData]);

  const toggleSyphilisTreatment = () => {
    setIsSyphilisTreatmentCollapsed(prev => !prev);
  };

  const [isStdInfoCollapsed, setIsStdInfoCollapsed] = useState(true);
  useEffect(() => {
    if (hasStdData) {
      setIsStdInfoCollapsed(false);
    } else {
      setIsStdInfoCollapsed(true);
    }
  }, [hasStdData]);
  const toggleStdInfo = () => {
    setIsStdInfoCollapsed(prev => !prev);
  };

  const hasTestingData =
    Boolean(selectedClient?.naat) ||
    Boolean(selectedClient?.hivAgAb) ||
    Boolean(selectedClient?.hivIa);

  const [isTestingInfoCollapsed, setIsTestingInfoCollapsed] = useState(true);
  useEffect(() => {
    if (hasTestingData) {
      setIsTestingInfoCollapsed(false);
    } else {
      setIsTestingInfoCollapsed(true);
    }
  }, [hasTestingData]);


  const toggleTestingInfo = () => {
    setIsTestingInfoCollapsed(prev => !prev);
  };

  const hasMedicalData =
    Boolean(selectedClient?.hospitalAdmit) ||
    Boolean(selectedClient?.symptoms) ||
    Boolean(selectedClient?.chiefComplaint) ||
    Boolean(selectedClient?.dateDischarged) ||
    Boolean(selectedClient?.datePresented);

  const [isMedicalCollapsed, setIsMedicalCollapsed] = useState(true);

  useEffect(() => {
    if (hasMedicalData) {
      setIsMedicalCollapsed(false);   // expand when any field has data
    } else {
      setIsMedicalCollapsed(true);    // collapse when all fields empty
    }
  }, [
    hasMedicalData
  ]);
  const toggleMedical = () => {
    setIsMedicalCollapsed(prev => !prev);
  };


  const handleSearch = (searchValue: string) => {
    setSearchTerm(searchValue);

    searchValue = searchValue.toLowerCase();
    if (!searchValue) {
      setFilteredData(clientData);
      return;
    }
    const filtered = clientData?.filter((row: any) => {
      const RecStatusText =
        row.sourceName == "FLCareLookUp" ? "New" : "Updated";

      return (
        row?.firstName?.toLowerCase().search(searchValue) >= 0 ||
        row?.middleName?.toLowerCase().search(searchValue) >= 0 ||
        row?.lastName?.toLowerCase().search(searchValue) >= 0 ||
        row?.routinizedHospitalName?.toLowerCase().search(searchValue) >= 0 ||
        row?.medicalRecord?.toLowerCase().search(searchValue) >= 0 ||
        row?.sourceIdNumber?.toLowerCase().search(searchValue) >= 0 ||
        row?.createdBy?.toLowerCase().search(searchValue) >= 0 ||
        row?.dateCreated?.toLowerCase().search(searchValue) >= 0 ||
        row?.updatedBy?.toLowerCase().search(searchValue) >= 0 ||
        row?.dateUpdated?.toLowerCase().search(searchValue) >= 0 ||
        RecStatusText.toLowerCase().search(searchValue) >= 0 ||
        row.linkageCareStatusName?.toLowerCase().search(searchValue) >= 0
      );
    });
    setFilteredData(filtered);
  };

  const ProviderColumn = [
    {
      name: <b>Hospital/Location</b>,
      selector: (row: any) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row.routinizedHospitalName ? `${row.routinizedHospitalName}` : "-"}
          <br></br>
          {row.routinizedHospitalName ? (
            <>&emsp;&emsp;- {row.routinizedFacilityName}</>
          ) : (
            ""
          )}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: <b>Provider MRN</b>,
      selector: (row: any) => (row.medicalRecord ? row.medicalRecord : "-"),
      sortable: true,
      width: "120px",
    },
    ...(roleName === "Admin"
      ? [
        {
          name: <b>eHARS #</b>,
          selector: (row: any) =>
            row.sourceName === "EHARS" ? row.sourceIdNumber : "-",
          sortable: true,
          width: "120px",
        },

        {
          name: <b>STARS Profile ID</b>,
          selector: (row: any) =>
            row.sourceName == "STARS" ? row.sourceIdNumber : "-",
          sortable: true,
        },
      ]
      : []),
    {
      name: <b>Rec Status</b>,
      selector: (row: any) =>
        row.sourceName == "FLCareLookUp" ? "New" : "Updated",
      sortable: true,
      width: "120px",
    },
    {
      name: <b>Linkage Status</b>,
      selector: (row: any) => {
        if (!row.linkageCareStatusName) {
          const currentDate = new Date();
          const dateToCompare = new Date(row.dateCreated);
          const timeDifference = currentDate.getTime() - dateToCompare.getTime();
          const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

          if (daysDifference <= 14) {
            return (
              <span style={{
                backgroundColor: "#FFF797", //Yellow
                borderRadius: "50px",
                padding: "10px",
                color: "black",
                fontWeight: "normal",
                lineHeight: "1.8",
              }}>
                Pending
              </span>
            );
          } else {
            return (
              <span style={{
                backgroundColor: "#F8D7DA", //Red
                borderRadius: "50px",
                padding: "10px",
                color: "black",
                fontWeight: "normal",
                lineHeight: "1.8",
              }}>
                Pending
              </span>
            );
          }
        }

        return row.linkageCareStatusName;
      },
      sortable: true,
      width: "180px",
    },

    {
      name: <b>Created by</b>,
      selector: (row: any) => row.createdBy,
      sortable: true,
      width: "180px",
    },
    {
      name: <b>Created Date</b>,
      selector: (row: any) => {
        const date = new Date(row.dateCreated);
        return date.toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // For AM/PM format
        });
      },
      sortable: true,
    },
    {
      name: <b>Last Updated by</b>,
      selector: (row: any) => (row.updatedBy ? row.updatedBy : "-"),
      sortable: true,
    },
    {
      name: <b>Last Updated Date</b>,
      selector: (row: any) => {
        if (!row.dateUpdated) {
          return "-"; // If dateUpdated is null or undefined, show "-"
        }

        const date = new Date(row.dateUpdated); // Parse the date
        return date.toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // For AM/PM format
        });
      },
      sortable: true,
    },
    {
      name: <b >Action</b>,
      selector: (row: any) => (
        <div>
          {(roleName === "Provider" || roleName === "Admin" || roleName === "STD Provider" || roleName === "HIV Provider") &&
            row.sourceName === "FLCareLookUp" && (
              <FontAwesomeIcon
                icon={faPenToSquare}
                style={{ cursor: "pointer" }}
                onClick={() => handleEditClick(row.clientId, row.sourceName, 1, "")}
              />
            )}
          {(roleName === "Provider" || roleName === "Admin" || roleName === "STD Provider" || roleName === "HIV Provider") &&
            (row.sourceName === "EHARS" || row.sourceName === "STARS") && (
              <FontAwesomeIcon
                icon={faPen}
                style={{ cursor: "pointer" }}
                onClick={() => handleEditClick(row.clientId, row.sourceName, 1, "Updated")}
              />
            )}
          &nbsp; &nbsp;
          <FontAwesomeIcon
            icon={faEye}
            style={{ cursor: "pointer" }}
            onClick={() => handleEditClick(row.clientId, row.sourceName, 2, "View")}
          />{" "}
          &nbsp;
          {/* <FontAwesomeIcon icon={faPen} /> &nbsp; */}
          {/* <FontAwesomeIcon icon={faPrint} /> &nbsp; */}
        </div>
      ),
      width: "100px",
    },
  ];
  const conditionalRowStyles = [
    {
      when: (row: any) => row.clientId === highlightedClientId,
      style: {
        backgroundColor: "#eaf4fe", // Light blue highlight, choose any color you prefer
        color: "black",
      },
    },
  ];

  //let isEditable = selectedClient?.sourceName === "FLCareLookUp";
  const [isEditable, setIsEditable] = useState<boolean>(
    selectedClient?.sourceName === "FLCareLookUp"
  );
  const [isSourceName, setSourceName] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isSTDProvider, setIsSTDProvider] = useState<boolean>(false);
  const [isHivProvider, setIsHivProvider] = useState<boolean>(false);
  const [showStdTestInfo, setShowStdTestInfo] = useState(false);

  const [ssnIsMasked, setssnIsMasked] = useState<boolean>(true);
  const [updatedEditable, setUpdatedEditable] = useState<boolean>(false);

  const { getDataById: getAllClients } = useGetData<any, string>(
    "Client/GetAllClients",
    "GET"
  );

  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/" + account.username,
    "GET"
  );

  const { getDataById: getClientDetails } = useGetData<any, string>(
    "Client/GetClientDetails",
    "GET"
  );

  const { getDataById: getRelationshipTypes } = useGetData<any, string>(
    "Client/Relationships",
    "GET"
  );

  const { postByObject: postUpdateClientDetails } = usePost<
    {
      success: boolean;
      message: string;
    },
    EditCaseRequest
  >("Client/UpdateClientDetails", "POST");

  const { getDataById: getRoutinizedHospitals } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedHospitals", "GET");

  const { getDataById: getRoutinizedFacilities } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedFacilities", "GET");

  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );

  const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );

  const { getDataById: getLinkageCareStatuses } = useGetData<
    RoleData[],
    string
  >("Client/LinkageCareStatuses", "GET");

  const mapToSelectOptions = (data: RoleData[]): SelectOption[] => {
    return data.map((item) => ({
      id: item.id.toString(),
      value: item.value,
    }));
  };

  //Updated STD Info
  const [UpdatedRprType, setUpdatedRprType] = useState<string>("");
  const [UpdatedRprType1, setUpdatedRprType1] = useState<string>("");
  const [UpdatedRprSpecimenCollectionDate, setUpdatedRprSpecimenCollectionDate] = useState<string>("");
  const [UpdatedRprSpecimenId, setUpdatedRprSpecimenId] = useState<string>("");
  const [UpdatedRprDetails, setUpdatedRprDetails] = useState<string>("");
  const [UpdatedRprTiter, setUpdatedRprTiter] = useState<string>("");

  const [UpdatedVdrlType, setUpdatedVdrlType] = useState<string>("");
  const [UpdatedVdrlType1, setUpdatedVdrlType1] = useState<string>("");
  const [UpdatedVdrlSpecimenCollectionDate, setUpdatedVdrlSpecimenCollectionDate] = useState<string>("");
  const [UpdatedVdrlSpecimenId, setUpdatedVdrlSpecimenId] = useState<string>("");
  const [UpdatedVdrlDetails, setUpdatedVdrlDetails] = useState<string>("");
  const [UpdatedVdrlTiter, setUpdatedVdrlTiter] = useState<string>("");

  const [UpdatedTpPaType, setUpdatedTpPaType] = useState<string>("");
  const [UpdatedTpPaType1, setUpdatedTpPaType1] = useState<string>("");
  const [UpdatedTpPaSpecimenCollectionDate, setUpdatedTpPaSpecimenCollectionDate] = useState<string>("");
  const [UpdatedTpPaSpecimenId, setUpdatedTpPaSpecimenId] = useState<string>("");
  const [UpdatedTpPaDetails, setUpdatedTpPaDetails] = useState<string>("");

  const [UpdatedFtaAbsType, setUpdatedFtaAbsType] = useState<string>("");
  const [UpdatedFtaAbsType1, setUpdatedFtaAbsType1] = useState<string>("");
  const [UpdatedFtaAbsSpecimenCollectionDate, setUpdatedFtaAbsSpecimenCollectionDate] = useState<string>("");
  const [UpdatedFtaAbsSpecimenId, setUpdatedFtaAbsSpecimenId] = useState<string>("");
  const [UpdatedFtaAbsDetails, setUpdatedFtaAbsDetails] = useState<string>("");

  const [UpdatedEiaType, setUpdatedEiaType] = useState<string>("");
  const [UpdatedEiaType1, setUpdatedEiaType1] = useState<string>("");
  const [UpdatedEiaDate, setUpdatedEiaDate] = useState<string>("");
  const [UpdatedEiaSpecimenId, setUpdatedEiaSpecimenId] = useState("");
  const [UpdatedEiaDetails, setUpdatedEiaDetails] = useState<string>("");

  const [UpdatedChlamydiaType, setUpdatedChlamydiaType] = useState<string>("");
  const [UpdatedChlamydiaType1, setUpdatedChlamydiaType1] = useState<string>("");
  const [UpdatedChlamydiaDate, setUpdatedChlamydiaDate] = useState<string>("");
  const [UpdatedChlamydiaSpecimenId, setUpdatedChlamydiaSpecimenId] = useState<string>("");
  const [UpdatedChlamydiaDetails, setUpdatedChlamydiaDetails] = useState<string>("");

  const [UpdatedGonorrheaType, setUpdatedGonorrheaType] = useState<string>("");
  const [UpdatedGonorrheaType1, setUpdatedGonorrheaType1] = useState<string>("");
  const [UpdatedGonorrheaSpecimenCollectionDate, setUpdatedGonorrheaSpecimenCollectionDate] = useState<string>("");
  const [UpdatedGonorrheaSpecimenId, setUpdatedGonorrheaSpecimenId] = useState<string>("");
  const [UpdatedGonorrheaDetails, setUpdatedGonorrheaDetails] = useState<string>("");

  //New saving logic for test type and result
  const [rPR_Type, setRPR_Type] = useState<string>("");
  const [rPR_Result, setRPR_Result] = useState<string>("");
  const [vDRL_Type, setVDRL_Type] = useState<string>("");
  const [vDRL_Result, setVDRL_Result] = useState<string>("");

  const [tPPA_Type, setTPPA_Type] = useState<string>("");
  const [tPPA_Result, setTPPA_Result] = useState<string>("");
  const [fTAABS_Type, setFTAABS_Type] = useState<string>("");
  const [fTAABS_Result, setFTAABS_Result] = useState<string>("");

  const [chlamydia_Type, setChlamydia_Type] = useState<string>("");
  const [chlamydia_Result, setChlamydia_Result] = useState<string>("");
  const [gonorrhea_Type, setGonorrhea_Type] = useState<string>("");
  const [gonorrhea_Result, setGonorrhea_Result] = useState<string>("");

  //Historic
  const [historicalRPR, setHistoricalRPR] = useState<HistoricalTestRow[]>([]);
  const [historicalVDRL, setHistoricalVDRL] = useState<HistoricalTestRow[]>([]);
  const [historicalFTAABS, setHistoricalFTAABS] = useState<HistoricalTestRow[]>([]);
  const [historicalTPPA, setHistoricalTPPA] = useState<HistoricalTestRow[]>([]);
  const [historicalEIA, setHistoricalEIA] = useState<HistoricalTestRow[]>([]);
  const [historicalChlamydia, setHistoricalChlamydia] = useState<HistoricalTestRow[]>([]);
  const [historicalGonorrhea, setHistoricalGonorrhea] = useState<HistoricalTestRow[]>([]);

  const toHistoricalStdRows = (
    rows: HistoricalTestRow[]
  ): StdTestInformationRow[] =>
    rows.map((row, index) => ({
      specimenDate: row.testSpecimenDate,
      specimenId: row.specimenId,
      details: row.qualitativeResult,
      titer: row.quantitativeResult,
      historyNumber: row.testHistoryRowNum
        ? row.testHistoryRowNum - 1
        : index + 1,
    }));

  const createStdTestGroup = (
    testName: string,
    currentRow: StdTestInformationRow,
    historicalRows: HistoricalTestRow[]
  ): StdTestInformationGroup => ({
    testName,
    rows: [
      ...(currentRow.specimenDate ||
      currentRow.specimenId ||
      currentRow.details ||
      currentRow.titer
        ? [currentRow]
        : []),
      ...toHistoricalStdRows(historicalRows),
    ],
  });

  const stdTestInformationGroups: StdTestInformationGroup[] = [
    createStdTestGroup(
      "RPR Test Information",
      {
        specimenDate: selectedClient?.rpR_Specimen_Collection_Date,
        specimenId: selectedClient?.rpR_Specimen_ID,
        details: selectedClient?.rpR_Details,
        titer: selectedClient?.rpR_Titer,
      },
      historicalRPR
    ),
    createStdTestGroup(
      "CSF-VDRL Test Information",
      {
        specimenDate: selectedClient?.vdrL_Specimen_Collection_Date,
        specimenId: selectedClient?.vdrL_Specimen_ID,
        details: selectedClient?.vdrL_Details,
        titer: selectedClient?.vdrL_Titer,
      },
      historicalVDRL
    ),
    createStdTestGroup(
      "TP-PA Information",
      {
        specimenDate: selectedClient?.tppA_Specimen_Collection_Date,
        specimenId: selectedClient?.tppA_Specimen_ID,
        details: selectedClient?.tppA_Details,
      },
      historicalTPPA
    ),
    createStdTestGroup(
      "FTA-ABS Information",
      {
        specimenDate: selectedClient?.ftA_ABS_Specimen_Collection_Date,
        specimenId: selectedClient?.ftA_ABS_Specimen_ID,
        details: selectedClient?.ftA_ABS_Details,
      },
      historicalFTAABS
    ),
    createStdTestGroup(
      "EIA Information",
      {
        specimenDate: selectedClient?.eiA_IgG_Specimen_Collection_Date,
        specimenId: selectedClient?.eiA_IgG_Specimen_ID,
        details: selectedClient?.eiA_IgG_Details,
      },
      historicalEIA
    ),
    createStdTestGroup(
      "Chlamydia [200] Test Information",
      {
        specimenDate: selectedClient?.chlamydiaDate,
        specimenId: selectedClient?.chlamydia_Specimen_ID,
        details: selectedClient?.chlamydia_Details,
      },
      historicalChlamydia
    ),
    createStdTestGroup(
      "Gonorrhea [300] Test Information",
      {
        specimenDate: selectedClient?.gonorrhea_Specimen_Collection_Date,
        specimenId: selectedClient?.gonorrhea_Specimen_ID,
        details: selectedClient?.gonorrhea_Details,
      },
      historicalGonorrhea
    ),
  ];

  const hasHistoricalStdData =
    historicalRPR.length > 0 ||
    historicalVDRL.length > 0 ||
    historicalTPPA.length > 0 ||
    historicalFTAABS.length > 0 ||
    historicalEIA.length > 0 ||
    historicalChlamydia.length > 0 ||
    historicalGonorrhea.length > 0;

  useEffect(() => {
    if (hasHistoricalStdData) {
      setIsStdCollapsed(false);
    }
  }, [hasHistoricalStdData]);

  const [clientInfoStatusTypeData, setClientInfoStatusTypeData] = useState<SelectOption[]>([]);


  const [userDetails, setUserDetails] = useState<UserDetails>();

  const hasFetched = useRef(false); // Declare outside useEffect

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUserId("");
        if (userData?.user) {
          setUserDetails({ ...userData.user }); // Update state
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (isAuthenticated && !hasFetched.current) {
      hasFetched.current = true; // Mark as fetched
      fetchUserData();
    }
  }, [isAuthenticated, getUserId]); // Dependency array

  useEffect(() => {
    const fetchRoutinizedHospitals = async () => {
      var data = await getRoutinizedHospitals("");
      if (data) {
        if (userDetails?.roleName == 'Provider' || userDetails?.roleName == 'Staff') {
          data = data.filter(
            (hospital) => hospital.value == userDetails.routinizedHospitalName
          )
        }
        const mappedData = data.map((item) => ({
          id: item.id.toString(),
          value: item.value,
        }));
        setAllRoutinizedHospitalsData([
          { id: "", value: "Select Hospital" },
          ...mappedData,
        ]);
      }
    };

    fetchRoutinizedHospitals();

    const fetchLinkageCareStatuses = async () => {
      try {
        const data = await getLinkageCareStatuses("");
        if (data) {
          const mappedRoles = data.map((item) => ({
            id: item.id.toString(),
            value: item.value,
          }));
          setallLinkageCareStatusesData([
            { id: "", value: "--" },
            ...mappedRoles,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };
    fetchLinkageCareStatuses();

    const fetchModeofTransmission = async () => {
      try {
        const dataMOT: RoleData[] = await getModeofTransmission("");
        if (dataMOT) {
          const mappedMOT = mapToSelectOptions(dataMOT);
          setallModeoftransmissionData([
            { id: "", value: "--" },
            ...mappedMOT,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };
    fetchModeofTransmission();
  }, [userDetails]);

  useEffect(() => {
    const fetchData = async () => {
      const stateData = await getStates("");
      const countyData = await getCounties("");
      const relationshipData = await getRelationshipTypes("");
      setStates(stateData || []);
      setCounties(countyData || []);
      setRelationshipTypes(relationshipData || []);
    };

    fetchData();
  }, []);

  const { getDataById: getTests } = useGetData<any, string>(
    "Client/Tests",
    "GET"
  );

  const { getDataById: getResults } = useGetData<any, string>(
    "Client/Results",
    "GET"
  );

  const { getDataById: getStatusTypes } = useGetData<any, string>(
    "Client/StatusTypes",
    "GET"
  );



  useEffect(() => {
    const loadStatusTypeData = async () => {
      const statusTypeData = await getStatusTypes("");
      if (statusTypeData) {
        setClientInfoStatusTypeData(statusTypeData);
      }
    };
    loadStatusTypeData();
  }, []);

  const [clientInfoTestData, setClientInfoTestData] = useState<SelectOption[]>([]);
  const [clientInfoResultData, setClientInfoResultData] = useState<SelectOption[]>([]);

  const [caseReportTestData, setCaseReportTestData] = useState<SelectOption[]>([]);
  const [caseReportResultData, setCaseReportResultData] = useState<SelectOption[]>([]);


  // --- The fix is here ---
  useEffect(() => {
    const loadResultData = async () => {
      const resultData = await getResults("");
      if (resultData) {
        setClientInfoResultData(resultData);
        setCaseReportResultData(resultData);
      }
    };

    const loadTestData = async () => {
      const testData = await getTests("");
      if (testData) {
        setClientInfoTestData(testData);
        setCaseReportTestData(testData);
      }
    };

    loadResultData();
    loadTestData();
  }, []); // Dependency array ensures it runs once (or when dependencies change)

  // ... rest of your component

  const handleRoutinizedHospitalChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const hospitalId = parseInt(e.target.value, 10);
    setSelectedHospitalId(hospitalId); // Update state with selected hospital ID
    setFilteredRoutinizedFacilities([]); // Clear facility options

    if (hospitalId) {
      const facilitiesData = await getRoutinizedFacilities(
        hospitalId.toString()
      );
      if (facilitiesData) {
        const mappedFacilities = facilitiesData.map((item) => ({
          id: item.id.toString(),
          value: item.value,
        }));
        setFilteredRoutinizedFacilities([
          { id: "", value: "Select Facility" },
          ...mappedFacilities,
        ]);
      }
    }
  };

  useEffect(() => {
    const loadData = async () => {
      let data = await getAllClients("");
      data = data.sort(
        (
          a: {
            dateUpdated: string | number | Date;
            dateCreated: string | number | Date;
          },
          b: {
            dateUpdated: string | number | Date;
            dateCreated: string | number | Date;
          }
        ) => {
          const dateA = a.dateUpdated
            ? new Date(a.dateUpdated).getTime()
            : new Date(a.dateCreated).getTime();
          const dateB = b.dateUpdated
            ? new Date(b.dateUpdated).getTime()
            : new Date(b.dateCreated).getTime();

          return dateB - dateA; // Sort in descending order
        }
      );
      setClientData(data);
      if (data) {
        // Set the original data
        setFilteredData(data); // Initialize the filtered data to show all rows initially
        const userData = await getUserId("");
        if (userData?.user?.isActive) {
          setIsAdmin(userData?.user?.roleName.toLowerCase() === "admin");
          setIsSTDProvider(userData?.user?.roleName.toLowerCase() === "std provider");
          setIsHivProvider(userData?.user?.roleName.toLowerCase() === "hiv provider");
          setShowStdTestInfo(userData?.user?.roleName.toLowerCase() === "hiv provider" || userData?.user?.roleName.toLowerCase() === "hiv staff")
          if (userData?.user?.roleName) {
            setRoleName(userData.user.roleName);
          }
          if (userData?.user?.roleName !== "Admin" || userData?.user?.roleName.toLowerCase() === "hiv provider") {
            const filterData = data.filter(
              (x: { routinizedHospitalId: any }) =>
                x.routinizedHospitalId === userData?.user?.routinizedHospitalId
            );
            setClientData(filterData);
            setFilteredData(filterData);
          }
        } else {
          navigate('/unauthorized');
        }
      }
    };
    loadData();
  }, []);

  const handleEditClick = async (
    clientId: string,
    sourceName: string,
    type: number,
    status: string
  ) => {
    try {
      setSourceName(sourceName);
      setType(status);

      if (type == 1) {
        setIsEditable(true);
      } else {
        setIsEditable(false);
      }
      if (status == "Updated") {
        //setIsEditable(false);
        setUpdatedEditable(true);
      }
      const clientDetails = await getClientDetails(clientId);
      setSyphilisTreatmentHistory(
        clientDetails?.treatmentHistoryResults ??
        clientDetails?.TreatmentHistoryResults ??
        []
      );
      const historicalTests = clientDetails?.historicalTests ?? [];
      const historicalRPR = historicalTests
        .filter((t: HistoricalTestRow) => t.testName === "RPR" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalVDRL = historicalTests
        .filter((t: HistoricalTestRow) => t.testName === "VDRL" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalFTAABS = historicalTests
        .filter((t: HistoricalTestRow) => t.testName === "FTA-ABS" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalTPPA = historicalTests
        .filter((t: HistoricalTestRow) => t.testName === "TP-PA" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalEIA = historicalTests
        .filter((t: HistoricalTestRow) => t.testName === "EIA-IgG" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalChlamydia = historicalTests
        .filter((t: HistoricalTestRow) => t.diseaseCategory?.toLowerCase() === "chlamydia" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      const historicalGonorrhea = historicalTests
        .filter((t: HistoricalTestRow) => t.diseaseCategory?.toLowerCase() === "gonorrhea" && t.resultType === "Historical")
        .sort((a: HistoricalTestRow, b: HistoricalTestRow) => a.testHistoryRowNum - b.testHistoryRowNum);

      setHistoricalRPR(historicalRPR);
      setHistoricalVDRL(historicalVDRL);
      setHistoricalFTAABS(historicalFTAABS);
      setHistoricalTPPA(historicalTPPA);
      setHistoricalEIA(historicalEIA);
      setHistoricalChlamydia(historicalChlamydia);
      setHistoricalGonorrhea(historicalGonorrhea);

      if (clientDetails) {

        const hospitalId = Number(
          allRoutinizedHospitalsData.find(
            (hospital) =>
              hospital.value === clientDetails.routinizedHospitalName
          )?.id
        );
        setSelectedHospitalId(isNaN(hospitalId) ? null : hospitalId);

        // Fetch facilities for the selected hospital
        if (hospitalId) {
          const facilitiesData = await getRoutinizedFacilities(
            hospitalId.toString()
          );
          const mappedFacilities = facilitiesData.map((item) => ({
            id: item.id.toString(),
            value: item.value,
          }));
          setFilteredRoutinizedFacilities([
            { id: "", value: "Select Facility" },
            ...mappedFacilities,
          ]);

          const facilityId = Number(
            mappedFacilities.find(
              (facility) =>
                facility.value === clientDetails.routinizedFacilityName
            )?.id
          );

          setSelectedFacilityId(isNaN(facilityId) ? null : facilityId);
        }

        setSelectedClient({
          ...clientDetails,
          routinizedHospitalName: clientDetails.routinizedHospitalName || "",
          routinizedFacilityName: clientDetails.routinizedFacilityName || "",
          birthGenderName: clientDetails.birthGenderName || "",
          relationshipId: clientDetails.relationshipId || "",

          updatedEiaDate: clientDetails.updatedEIADate,

        });

      }
      isCaseReportRef.current = clientDetails.isCaseReport;
      const selectedType = clientDetails.street1 ? "Yes" : "No";
      setAddressType(selectedType);
      setIsAddressRequired(selectedType === "Yes"); // "Yes" means Home Address
      setSelectedClient((prev: any) => ({ ...prev, addressTypeDetailNewCase: selectedType }));
      setupdateCaseReportValidationErrors((prevErrors) => ({
        ...prevErrors,
        addressTypeDetailNewCase: selectedType ? "" : prevErrors.addressTypeDetailNewCase,
      }));

      setHighlightedClientId(Number(clientId));
      setAddressType("")
      setupdateCaseReportValidationErrors({});
      setShowEditForm(true); // Show the form

      // Move focus to the edit section
      setTimeout(() => {
        editSectionRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Failed to fetch client details:", error);
    }
  };

  type NavItem = { id: string; label: string };
  const isUpdatedRecord = selectedClient?.sourceName !== "FLCareLookUp";
  const navItems: NavItem[] = [
    { id: 'PatientIdentification', label: 'Patient Identification' },
    { id: 'PatientContactInformation', label: 'Patient Contact Information' },
    { id: 'EmergencyContactInformation', label: 'Emergency Contact Information' },
    { id: 'MedicalInformation', label: 'Medical Information' },
    { id: 'LinkageToCareStatus', label: 'Linkage to Care Status' },
    { id: 'TestingInformation', label: 'Testing Information' },
    { id: 'HIVDetails', label: 'HIV Diagnosis Details' },
    //{ id: 'UpdatedHIVDetails', label: 'Updated HIV Diagnosis Details' },
    ...(isUpdatedRecord
      ? [{ id: 'UpdatedHIVDetails', label: 'Updated HIV Diagnosis Details' }
      ]
      : []),
    { id: 'STDTestInformation', label: 'STD Test Information' },
    { id: 'SyphilisTreatmentInformation', label: 'STD Treatment History' },
    //{ id: 'UpdatedSTDTestInformation', label: 'Updated STD Test Information' },

    // // Conditionally include STD sections when source is not HIV
    ...(isUpdatedRecord
      ? [{ id: 'UpdatedSTDTestInformation', label: 'Updated STD Test Information' }
      ]
      : []),

    // Conditionally include Pregnancy section for female birth gender
    ...(selectedClient?.birthGenderName?.toLowerCase() === 'female'
      ? [{ id: 'PregnancyInformation', label: 'Pregnancy Information' }]
      : []),

    { id: 'AdditionalNotes', label: 'Additional Notes' },
  ];

  const isFieldDisabled = (field: string) => {
    if (!isEditable) {
      return true;
    }
    if (field === "hospitalLocation" || field === "hospitalRoom") {
      return !selectedClient.hospitalAdmit;
    }
    return false;
  };

  const handleAddressTypeChange = (e: { target: { value: any; }; }) => {
    const selectedType = e.target.value;
    setAddressType(selectedType);
    setIsAddressRequired(selectedType === "Yes"); // "Yes" means Home Address

    setupdateCaseReportValidationErrors((prevErrors) => ({
      ...prevErrors,
      addressTypeDetailNewCase: selectedType ? "" : prevErrors.addressTypeDetailNewCase,
    }));
  };

  const [
    updateCaseReportValidationErrors,
    setupdateCaseReportValidationErrors,
  ] = useState<{
    [key: string]: string;
  }>({});

  const {
    register,
    getValues,
    reset,
    trigger,
    setValue
  } = useForm({
    resolver: yupResolver(TestingInformationValidation),
    defaultValues: {
      section1: true,
      section2: false,
      section3: false
    }
  });

  const handleSave = async () => {
    if (!selectedClient) {
      toast.error("No client selected for update.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }
    setValue("firstName", selectedClient.firstName)
    setValue("lastName", selectedClient.lastName)
    setValue("dob", selectedClient.dob)
    setValue("CaseBirthGender", selectedClient.birthGenderName)
    setValue("pregnantId", selectedClient.pregnantId)

    // Prepare the request payload
    const payload: EditCaseRequest = {
      clientId: selectedClient.clientId,
      caseReportId: selectedClient.caseReportId,
      firstName: selectedClient.firstName,
      middleName: selectedClient.middleName || null,
      lastName: selectedClient.lastName,
      dob: selectedClient.dob,
      birthGenderName: selectedClient.birthGenderName,
      street1: selectedClient.street1,
      street2: selectedClient.street2,
      city: selectedClient.city,
      stateName: selectedClient.stateName, // State Name from UI
      countyName: selectedClient.countyName, // County Name from UI
      zipCode: selectedClient.zipCode,
      primaryPhone: selectedClient.primaryPhone,
      secondPhone: selectedClient.secondPhone,
      comments: selectedClient.comments,
      ssn: selectedClient.ssn || null,
      erContactName: selectedClient.erContactName,
      relationshipId: selectedClient.relationshipId || null,
      erContactPhone: selectedClient.erContactPhone,
      routinizedHospitalName: selectedClient.routinizedHospitalName,
      routinizedFacilityName: selectedClient.routinizedFacilityName,
      chiefComplaint: selectedClient.chiefComplaint,
      symptoms: selectedClient.symptoms,
      datePresented: selectedClient.datePresented,
      dateDischarged: selectedClient.dateDischarged,
      medicalRecord: selectedClient.medicalRecord,
      dateReceived: selectedClient.dateReceived,
      dateTest: selectedClient.dateTest,
      rprTest: selectedClient.rprTest,
      tppaTest: selectedClient.tppaTest,
      ftaAbsTest: selectedClient.ftaAbsTest,
      _200Test: selectedClient._200Test,
      _300Test: selectedClient._300Test,
      treatment: selectedClient.treatment,
      naat: selectedClient.naat,
      hivAgAb: selectedClient.hivAgAb,
      hivIa: selectedClient.hivIa,
      disclosed: selectedClient.disclosed,
      inCare: selectedClient.inCare,
      isSelfReported: selectedClient.isSelfReported,
      isPositiveTest: selectedClient.isPositiveTest,
      isCaseReport: selectedClient.isCaseReport,
      medication: selectedClient.medication,
      dateLabs: selectedClient.dateLabs,
      pregnantId: selectedClient.pregnantId,
      edd: selectedClient.edd,
      dateLmp: selectedClient.dateLmp,
      hospitalAdmit: selectedClient.hospitalAdmit,
      hospitalLocation: selectedClient.hospitalLocation,
      hospitalRoom: selectedClient.hospitalRoom,
      modeofTransmission: selectedClient.modeofTransmission,
      additionalNotes: selectedClient.additionalNotes,
      dohNotes: selectedClient.dohNotes,
      viralLoad: selectedClient.viralLoad,
      cd4count: selectedClient.cd4count,
      naatdate: selectedClient.naatdate,
      hivAgAbDate: selectedClient.hivAgAbDate,
      hivIaDate: selectedClient.hivIaDate,
      inCareDate: selectedClient.inCareDate,
      disclosedDate: selectedClient.disclosedDate,
      linkageCareStatusId: selectedClient.linkageCareStatusId,
      linkageCareStatusOtherDetails: selectedClient.linkageCareStatusOtherDetails,
      updatedBy: account.name,
      addressTypeDetailNewCase: selectedClient.addressTypeDetailNewCase,
      rpR_Specimen_Collection_Date: selectedClient.rpR_Specimen_Collection_Date,
      rpR_Specimen_ID: selectedClient.rpR_Specimen_ID,
      rpR_Details: selectedClient.rpR_Details,
      rpR_Titer: selectedClient.rpR_Titer,
      vdrL_Specimen_Collection_Date: selectedClient.vdrL_Specimen_Collection_Date,
      vdrL_Specimen_ID: selectedClient.vdrL_Specimen_ID,
      vdrL_Details: selectedClient.vdrL_Details,
      vdrL_Titer: selectedClient.vdrL_Titer,
      tppA_Specimen_Collection_Date: selectedClient.tppA_Specimen_Collection_Date,
      tppA_Specimen_ID: selectedClient.tppA_Specimen_ID,
      tppA_Details: selectedClient.tppA_Details,
      ftA_ABS_Specimen_Collection_Date: selectedClient.ftA_ABS_Specimen_Collection_Date,
      ftA_ABS_Specimen_ID: selectedClient.ftA_ABS_Specimen_ID,
      ftA_ABS_Details: selectedClient.ftA_ABS_Details,
      EIA_IgG_Specimen_Collection_Date: selectedClient.eiA_IgG_Specimen_Collection_Date,
      EIA_IgG_Specimen_ID: selectedClient.eiA_IgG_Specimen_ID,
      EIA_IgG_Details: selectedClient.eiA_IgG_Details,
      chlamydiaDate: selectedClient.chlamydiaDate,
      chlamydia_Specimen_ID: selectedClient.chlamydia_Specimen_ID,
      chlamydia_Details: selectedClient.chlamydia_Details,
      gonorrhea_Specimen_Collection_Date: selectedClient.gonorrhea_Specimen_Collection_Date,
      gonorrhea_Specimen_ID: selectedClient.gonorrhea_Specimen_ID,
      gonorrhea_Details: selectedClient.gonorrhea_Details,
      last_cd4_count_date: selectedClient.last_cd4_count_date,
      last_viral_load_date: selectedClient.last_viral_load_date,
      linkageToCareStatusForHivDiagnosis: selectedClient.linkageToCareStatusForHivDiagnosis,
      updatedEditable: updatedEditable.toString(),
      updatedHivdateofDiagnosis: selectedClient.updatedHIVDateofDiagnosis,
      updatedViralLoad: selectedClient.updatedViralLoad,
      updatedCd4count: selectedClient.updatedCD4Count,
      updatedlast_cd4_count_date: selectedClient.updatedlast_cd4_count_date,
      updatedlast_viral_load_date: selectedClient.updatedlast_viral_load_date,
      updatedLinkageToCareStatusForHivDiagnosis: selectedClient.updatedLinkageToCareStatusForHivDiagnosis,
      aidsDate: selectedClient.aidsDate,
      hivReportedDate: selectedClient.hivReportedDate,
      hivmodeOfTransmissionId: selectedClient.hivmodeOfTransmissionId,
      updatedAidsDate: selectedClient.updatedAidsDate,
      updatedHivReportedDate: selectedClient.updatedHivReportedDate,
      updatedHivmodeOfTransmissionId: selectedClient.updatedHivmodeOfTransmissionId,

      //Updated STD Info
      UpdatedRprType: selectedClient.updatedRprType,
      UpdatedRprSpecimenCollectionDate: selectedClient.updatedRprSpecimenCollectionDate,
      UpdatedRprSpecimenId: selectedClient.updatedRprSpecimenId,
      UpdatedRprDetails: selectedClient.updatedRprDetails,
      UpdatedRprTiter: selectedClient.updatedRprTiter,

      UpdatedVdrlType: selectedClient.updatedVdrlType,
      UpdatedVdrlSpecimenCollectionDate: selectedClient.updatedVdrlSpecimenCollectionDate,
      UpdatedVdrlSpecimenId: selectedClient.updatedVdrlSpecimenId,
      UpdatedVdrlDetails: selectedClient.updatedVdrlDetails,
      UpdatedVdrlTiter: selectedClient.updatedVdrlTiter,

      UpdatedTpPaType: selectedClient.updatedTpPaType,
      UpdatedTpPaSpecimenCollectionDate: selectedClient.updatedTpPaSpecimenCollectionDate,
      UpdatedTpPaSpecimenId: selectedClient.updatedTpPaSpecimenId,
      UpdatedTpPaDetails: selectedClient.updatedTpPaDetails,
      UpdatedTpPaTiter: selectedClient.updatedTpPaTiter,

      UpdatedFtaAbsType: selectedClient.updatedFtaAbsType,
      UpdatedFtaAbsSpecimenCollectionDate: selectedClient.updatedFtaAbsSpecimenCollectionDate,
      UpdatedFtaAbsSpecimenId: selectedClient.updatedFtaAbsSpecimenId,
      UpdatedFtaAbsDetails: selectedClient.updatedFtaAbsDetails,
      UpdatedFtaAbsTiter: selectedClient.updatedFtaAbsTiter,

      updatedEIAType: selectedClient.updatedEIA_Type,
      updatedEIADate: selectedClient.updatedEiaDate,
      updatedEIASpecimenId: selectedClient.updatedEIASpecimenId,
      updatedEIADetails: selectedClient.updatedEiaDetails,
      updatedEIATiter: selectedClient.updatedEiaTiter,

      UpdatedChlamydiaType: selectedClient.updatedChlamydiaType,
      UpdatedChlamydiaDate: selectedClient.updatedChlamydiaDate,
      UpdatedChlamydiaSpecimenId: selectedClient.updatedChlamydiaSpecimenId,
      UpdatedChlamydiaDetails: selectedClient.updatedChlamydiaDetails,
      UpdatedChlamydiaTiter: selectedClient.updatedChlamydiaTiter,

      UpdatedGonorrheaType: selectedClient.updatedGonorrheaType,
      UpdatedGonorrheaSpecimenCollectionDate: selectedClient.updatedGonorrheaSpecimenCollectionDate,
      UpdatedGonorrheaSpecimenId: selectedClient.updatedGonorrheaSpecimenId,
      UpdatedGonorrheaDetails: selectedClient.updatedGonorrheaDetails,
      UpdatedGonorrheaTiter: selectedClient.updatedGonorrheaTiter,


      rPR_Type: selectedClient.rpR_Type,
      rPR_Result: selectedClient.rpR_Result,
      vDRL_Type: selectedClient.vdrL_Type,
      vDRL_Result: selectedClient.vdrL_Result,
      tPPA_Type: selectedClient.tppA_Type,
      tPPA_Result: selectedClient.tppA_Result,
      fTAABS_Type: selectedClient.ftaabS_Type,
      fTAABS_Result: selectedClient.ftaabS_Result,
      eIAIgG_Type: selectedClient.eiaIgG_Type,
      eIAIgG_Result: selectedClient.eiaIgG_Result,
      chlamydia_Type: selectedClient.chlamydia_Type,
      chlamydia_Result: selectedClient.chlamydia_Result,
      gonorrhea_Type: selectedClient.gonorrhea_Type,
      gonorrhea_Result: selectedClient.gonorrhea_Result,

      //Updated STDinfo in fc.STDInfo table
      updatedRPR_Type: selectedClient.updatedRPR_Type,
      updatedRPR_Result: selectedClient.updatedRPR_Result,
      updatedVDRL_Type: selectedClient.updatedVDRL_Type,
      updatedVDRL_Result: selectedClient.updatedVDRL_Result,
      updatedTPPA_Type: selectedClient.updatedTPPA_Type,
      updatedTPPA_Result: selectedClient.updatedTPPA_Result,
      updatedFTAABS_Type: selectedClient.updatedFTAABS_Type,
      updatedFTAABS_Result: selectedClient.updatedFTAABS_Result,
      updatedEIA_Type: selectedClient.updatedEIA_Type,
      updatedEIA_Result: selectedClient.updatedEIA_Result,
      updatedChlamydia_Type: selectedClient.updatedChlamydia_Type,
      updatedChlamydia_Result: selectedClient.updatedChlamydia_Result,
      updatedGonorrhea_Type: selectedClient.updatedGonorrhea_Type,
      updatedGonorrhea_Result: selectedClient.updatedGonorrhea_Result,
    };

    let testingInformationValues = getValues();

    setIsSaving(true); // Disable the button
    if (
  selectedClient?.isPositiveTest === true &&
  selectedClient?.isCaseReport === false &&
  (!selectedClient?.naat || selectedClient.naat === "0")
) {
  setupdateCaseReportValidationErrors((prev: any) => ({
    ...prev,
    naat: "NAAT is required.",
  }));

  setIsSaving(false);

  const firstErrorElement =
    document.querySelector('[name="naat"]');

  if (firstErrorElement) {
    (firstErrorElement as HTMLElement).focus();
  }

  return;
}
    // Validate patient identification fields
    const patientValidation = TestingInformationValidation.validate(
      testingInformationValues,
      { abortEarly: false, }
    );

    patientValidation.then(async () => {
      if (!showTestingInformationError && selectedClient?.isCaseReport === false && !isSTDProvider) {
        toast.error('Enter at least one test information', { position: 'top-right', autoClose: 2000 });
        setIsSaving(false);
        const firstErrorElement = document.querySelector('[name=naat]');
        if (firstErrorElement)
          (firstErrorElement as HTMLElement).focus();
        return;
      } else {
        // If validation passes, proceed with API call
        const response = await postUpdateClientDetails(payload);
        if (response?.success) {
          toast.success(response.message, {
            position: "top-right",
            autoClose: 2000,
          });

          setShowEditForm(false);
          setSelectedClient(null);
          navigate('/dashboard');
          const updatedData = await getAllClients("");
          setClientData(updatedData);
        } else {
          toast.error(response?.message || "Failed to update client details.", {
            position: "top-right",
            autoClose: 2000,
          });
          console.error("Error:", response?.message);
        }
      }
    }).catch((error) => {
      const updateCaseReportValidationErrors: { [key: string]: string } = {};
      error.inner.forEach((err: any) => {
        updateCaseReportValidationErrors[err.path] = err.message;
      });
      setupdateCaseReportValidationErrors(updateCaseReportValidationErrors);

      toast.error("An Error Occured while updating Case Report.", {
        position: "top-right",
        autoClose: 2000,
      });

      const firstErrorField = Object.keys(updateCaseReportValidationErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorField}"]`
      );
      if (firstErrorElement) {
        (firstErrorElement as HTMLElement).focus();
      }
    });
    setIsSaving(false);
  };
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setMaxDate(formattedDate);
  }, []);

  const [isChecked, setIsChecked] = useState(false);
  const [isError, setError] = useState(false);

  //Updated HIV 

  const [updatedLinkageToCareStatusForHivDiagnosis, setUpdatedLinkageToCareStatusForHivDiagnosis] = useState<string>("");
  const [updatedcaseReportCD4, setUpdatedCaseReportCD4] = useState<string>("");

  const [updatedClientInfoHivDateOfDiagnosis, setUpdatedClientInfoHivDateOfDiagnosis] = useState<string>("");
  const [updatedClientInfoViralLoad, setUpdatedClientInfoViralLoad] = useState<string>("");
  const [updatedClientInfoCD4Count, setUpdatedClientInfoCD4Count] = useState<string>("");
  const [updatedL2CName, setUpdatedL2CName] = useState<string>("");
  const [updatedLastUpdatedDate, setUpdatedLastUpdatedDate] = useState({
    lastViralLoad: "",
    lastCd4: "",
    dateOfDiagnosis: ""
  });

  useEffect(() => {
    setUpdatedClientInfoViralLoad(selectedClient?.updatedViralLoad || "");
    setUpdatedLastUpdatedDate(prev => ({
      ...prev,
      dateOfDiagnosis: selectedClient?.updatedHIVDateofDiagnosis?.split('T')[0] ?? ""
    }));

    setUpdatedLastUpdatedDate(prev => ({
      ...prev,
      lastViralLoad: selectedClient?.updatedlast_viral_load_date?.split('T')[0] ?? ""
    }));

    setUpdatedLastUpdatedDate(prev => ({
      ...prev,
      lastCd4: selectedClient?.updatedlast_cd4_count_date?.split('T')[0] ?? ""
    }));

    setUpdatedL2CName(selectedClient?.updatedLinkageToCareStatusForHivDiagnosis);
    setUpdatedClientInfoCD4Count(selectedClient?.updatedCD4Count);
    if (type == "Updated") {
      setIsEditable(false);
    } else if (type == "View") {
      setIsEditable(false);

      setUpdatedEditable(false)

    }

  }, [selectedClient, type]);

  const handleIsPositiveTestSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setSelectedClient((prev: any) => ({ ...prev, isPositiveTest: checked, isCaseReport: false }))
    isCaseReportRef.current = false;
    setIsSaving(false);
    setShowTestingInformationError(false);
  }

  const handleIsCaseReportSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setShowTestingInformationError(true);
    setSelectedClient((prev: any) => ({
      ...prev,
      isCaseReport: checked,
      isPositiveTest: false,
      naat: '',
      naatdate: '',
      disclosed: '',
      disclosedDate: '',
      hivAgAb: '',
      hivAgAbDate: '',
      inCare: '',
      inCareDate: '',
      hivIa: '',
      hivIaDate: '',
      linkageCareStatusId: '',
      medication: ''
    }));

    setValue("naat", "");
    setValue("naatDate", "");
    setValue("disclosed", "");
    setValue("disclosedDate", "")
    setValue("hivAgAb", "");
    setValue("hivAgAbDate", "");
    setValue("inCare", "");
    setValue("inCareDate", "");
    setValue("hivIa", "");
    setValue("hivIaSupplementalDate", "");
    handleSectionValidation(false, false, false);
    isCaseReportRef.current = checked;
    let testingInformationValues = getValues();

    setIsSaving(true); // Disable the button
    // Validate patient identification fields
    const patientValidation = TestingInformationValidation.validate(
      testingInformationValues,
      { abortEarly: false, }
    );

    patientValidation.catch((error) => {
      const updateCaseReportValidationErrors: { [key: string]: string } = {};
      error.inner.forEach((err: any) => {
        updateCaseReportValidationErrors[err.path] = err.message;
      });
      setupdateCaseReportValidationErrors(updateCaseReportValidationErrors);
    });
    setIsSaving(false);
  }

  useEffect(() => {
    if (selectedClient) {
      const requiredFields = [selectedClient.naat, selectedClient.disclosed, selectedClient.hivAgAb, selectedClient.inCare, selectedClient.hivIa];
      const allFieldsInvalid = requiredFields.filter(item => item !== "0" && item != "" && item);
      setShowTestingInformationError(allFieldsInvalid.length > 0);
    }
  }, [selectedClient?.naat, selectedClient?.disclosed, selectedClient?.hivAgAb, selectedClient?.inCare, selectedClient?.hivIa])

  const handleSectionValidation = (section1: boolean, section2: boolean, section3: boolean) => {
    setValue('section1', section1);
    setValue('section2', section2);
    setValue('section3', section3);
  }

  const handleFormFieldChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    const fieldName = name as keyof providerDashboardSchema;
    setValue(fieldName, value, {
      shouldValidate: true,
      shouldDirty: true
    });

    TestingInformationValidation
      .validateAt(fieldName, { [fieldName]: value })
      .then(() => {
        setupdateCaseReportValidationErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[fieldName];
          return newErrors;
        });
      })
      .catch((validationErrors) => {
        setupdateCaseReportValidationErrors(prev => ({
          ...prev,
          [fieldName]: validationErrors.message
        }));
      });
  }

  const handleTestingInformationTitle = (
    <div className="w-100">
      <div className="section-header">


        <span className="section-title">
          Testing Information{" "}
          {!showTestingInformationError && !isCaseReportRef.current ? (
            <span className="px-3 fs-6" style={{ color: "#ffcc00", fontWeight: 600 }}>
              Enter at least one test information
            </span>
          ) : null}
        </span>

        <div className="d-flex align-items-center" style={{ gap: "8px", marginRight: "12px" }}>
          <Form.Check
            type="checkbox"
            id="custom-checkbox"
            checked={
              !selectedClient?.isPositiveTest && !selectedClient?.isCaseReport
                ? true
                : selectedClient?.isPositiveTest
            }
            onChange={(e) => {
              handleIsPositiveTestSelect(e);
              setShowTestingInformationError(false);
            }}
          />
          <span className="me-2" style={{ fontSize: "1rem" }}>
            T1: Positive Test Result
          </span>

          <Form.Check
            {...register("caseReportCheckBox")}
            type="checkbox"
            id="custom-checkbox"
            checked={selectedClient?.isCaseReport}
            onChange={(e) => {
              handleIsCaseReportSelect(e);
              setShowTestingInformationError(true);
            }}
          />
          <span className="me-2" style={{ fontSize: "1rem" }}>
            T2: Case Report
          </span>
        </div>

        <span
          onClick={toggleTestingInfo}
          className="section-toggle"
        >
          {isTestingInfoCollapsed ? "+" : "−"}
        </span>
      </div>
    </div>

  )

  return (
    <>
      <div>
        <div>
          <Row className="mb-3">
            <Col>
              <AppCard
                title="Florida Health Care Lookup Dashboard"
                bottomMargin
              //marginLeft={`${isAdmin?'21rem':'0rem'}`}
              >
                <Row>
                  <Col>
                    <AppDataTable
                      columns={ProviderColumn}
                      data={filteredData}
                      search={true}
                      pagination={true}
                      searchCallBack={handleSearch}
                      conditionalRowStyles={conditionalRowStyles}
                      noDataComponent={undefined}
                    />
                  </Col>
                </Row>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#FFF797",
                        borderRadius: "50px",
                        padding: "10px",
                        color: "black",
                        fontWeight: "normal",
                        lineHeight: "1.8",
                        display: "inline-block",
                        marginRight: "10px",
                      }}
                    ></span>
                    <span>Pending for update under 14 days</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#F8D7DA",
                        borderRadius: "50px",
                        padding: "10px",
                        color: "black",
                        fontWeight: "normal",
                        lineHeight: "1.8",
                        display: "inline-block",
                        marginRight: "10px",
                      }}
                    ></span>
                    <span>Pending for update over 14 days&nbsp;&nbsp;</span>
                  </div>
                </div>

              </AppCard>
            </Col>
          </Row>
        </div>

        {/* Editable Form */}
        {showEditForm && selectedClient && (
          <Container>
            <div style={{ marginTop: "20px", marginBottom: '20px', border: '1px solid #dee2e6', borderRadius: '5px' }} ref={editSectionRef}>
              <div>
                <div style={{ backgroundColor: '#005F85', color: 'whitesmoke', height: '30px' }}><h4 className="p-1">Edit Client Details</h4></div>
                {/* Section 1: Patient Information */}
                <AppCard title={
                  <div className="w-100" id="PatientIdentification">
                    <div className="section-header">
                      <span className="section-title">
                        Patient Identification
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Routinized Hospital" required />
                        <Form.Select
                          value={
                            allRoutinizedHospitalsData.find(
                              (h) => h.value === selectedClient?.routinizedHospitalName
                            )?.id || ""
                          }
                          {...register('routinizedHospitalName')}
                          name="routinizedHospitalName"
                          onChange={(e) => {
                            const selectedHospitalId = parseInt(
                              e.target.value,
                              10
                            ); // Convert ID to number
                            const selectedHospitalName =
                              allRoutinizedHospitalsData.find(
                                (hospital) => hospital.id === e.target.value
                              )?.value;

                            setSelectedClient({
                              ...selectedClient,
                              // If user selected the placeholder "Select Hospital", set it to empty string
                              routinizedHospitalName:
                                selectedHospitalName === "Select Hospital"
                                  ? ""
                                  : selectedHospitalName,
                            });

                            setSelectedHospitalId(
                              isNaN(selectedHospitalId)
                                ? null
                                : selectedHospitalId
                            ); // Update ID
                            handleRoutinizedHospitalChange(e); // Fetch facilities
                          }}
                          disabled={!isEditable && !updatedEditable}
                        //disabled={isAdmin ? !isAdmin : !isEditable}
                        >
                          {(isAdmin
                            ? allRoutinizedHospitalsData
                            : allRoutinizedHospitalsData.filter(
                              (option) => option.value === selectedClient?.routinizedHospitalName
                            )
                          ).map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>

                        <div className="error m-0">
                          {
                            updateCaseReportValidationErrors.routinizedHospitalName
                          }
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label="Routinized Facility" required />
                        <Form.Select
                          {...register('routinizedFacilityName')}
                          value={
                            filteredRoutinizedFacilities.find(
                              (f) =>
                                f.value ===
                                selectedClient?.routinizedFacilityName
                            )?.id || ""
                          }
                          name="routinizedFacilityName"
                          onChange={(e) => {
                            const selectedFacilityId = parseInt(
                              e.target.value,
                              10
                            ); // Convert ID to number
                            const selectedFacilityName =
                              filteredRoutinizedFacilities.find(
                                (facility) => facility.id === e.target.value
                              )?.value;

                            setSelectedClient({
                              ...selectedClient,
                              routinizedFacilityName:
                                selectedFacilityName === "Select Facility"
                                  ? ""
                                  : selectedFacilityName,
                            });

                            setSelectedFacilityId(
                              isNaN(selectedFacilityId)
                                ? null
                                : selectedFacilityId
                            ); // Update ID
                          }}
                          disabled={!isEditable && !updatedEditable}
                        //disabled={isAdmin ? !isAdmin : !isEditable}
                        >
                          {filteredRoutinizedFacilities.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {
                            updateCaseReportValidationErrors.routinizedFacilityName
                          }
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Medical Record" required />
                        <Form.Control
                          {...register('medicalRecord')}
                          type="text"
                          name="medicalRecord"
                          value={selectedClient.medicalRecord || ""}
                          maxLength={25}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              medicalRecord: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                        //disabled={isAdmin ? !isAdmin : !isEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.medicalRecord}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label="Date Received" required />
                        <Form.Control
                          {...register('dateReceived')}
                          type="date"
                          value={
                            selectedClient.dateReceived
                              ? new Date(selectedClient.dateReceived)
                                .toISOString()
                                .split("T")[0]
                              : ""
                          }
                          onChange={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dateReceived: date
                            })
                            setValue('dateReceived', e.target.value);
                          }}
                          onBlur={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dateReceived: date,
                            })
                          }}
                          max={maxDate}
                          min={minDate}
                          disabled={!isEditable && !updatedEditable}
                        //disabled={isAdmin ? !isAdmin : !isEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.dateReceived}
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="First Name" required />
                        <Form.Control
                          {...register('firstName')}
                          type="text"
                          name="firstName"
                          value={selectedClient.firstName || ""}
                          onChange={(e) => {
                            setSelectedClient({
                              ...selectedClient,
                              firstName: e.target.value,
                            })
                            setValue('firstName', e.target.value);
                          }}
                          disabled={!isEditable}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.firstName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label="Middle Name" />
                        <Form.Control
                          type="text"
                          value={selectedClient.middleName || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              middleName: e.target.value,
                            })
                          }
                          disabled={!isEditable}
                          maxLength={30}
                        />
                      </Col>
                      <Col>
                        <AppLabel label="Last Name" required />
                        <Form.Control
                          {...register('lastName')}
                          type="text"
                          name="lastName"
                          value={selectedClient.lastName || ""}
                          onChange={(e) => {
                            setSelectedClient({
                              ...selectedClient,
                              lastName: e.target.value,
                            })
                            setValue('lastName', e.target.value);
                          }}
                          disabled={!isEditable}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.lastName}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Date of Birth" required />
                        <Form.Control
                          {...register('dob')}
                          type="date"
                          value={
                            selectedClient.dob
                              ? new Date(selectedClient.dob)
                                .toISOString()
                                .split("T")[0]
                              : ""
                          }

                          onChange={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dob: date
                            })
                            setValue('dob', e.target.value);
                          }}
                          onBlur={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dateReceived: date,
                            })
                          }}
                          max={maxDate}
                          min={minDate}
                          disabled={!isEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.dob}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Birth Sex"}></AppLabel>
                        <Form.Select
                          {...register("CaseBirthGender")}
                          value={selectedClient.birthGenderName} // Show the previous value
                          onChange={(e) => {
                            setSelectedClient({
                              ...selectedClient,
                              birthGenderName: e.target.value, // Update on change                                 
                            })

                          }}
                          disabled={!isEditable}
                        >
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                        </Form.Select>
                      </Col>
                      <Col>
                        <AppLabel label="Last 4 of SSN" />
                        <Form.Control
                          type="text"
                          value={
                            (ssnIsMasked ? "****" : selectedClient.ssn) ||
                            ""
                          }
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setSelectedClient({
                              ...selectedClient,
                              ssn: value,
                            });
                          }}
                          maxLength={4}
                          onBlur={() => {
                            if (selectedClient.ssn.length === 4) {
                              setssnIsMasked(true);
                            }
                          }}
                          onFocus={() => setssnIsMasked(false)}
                          disabled={!isEditable}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </AppCard>
                <AppCard title={
                  <div className="w-100" id="PatientContactInformation">
                    <div className="section-header">
                      <span className="section-title">
                        Patient Contact Information
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Address Type"} />
                        <Form.Select
                          name="addressTypeDetailNewCase"
                          onChange={(e) => {
                            handleAddressTypeChange(e); // Updates addressType state
                            setSelectedClient({
                              ...selectedClient,
                              addressTypeDetailNewCase: e.target.value, // Ensure this updates in form data
                              street1: e.target.value === "Yes" ? selectedClient.street1 : ''
                            });
                          }}
                          value={selectedClient.addressTypeDetailNewCase}
                          disabled={!isEditable && !updatedEditable}
                        >
                          <option value="">--</option>
                          <option value="Yes">Home Address</option>
                          <option value="No">Unhoused</option>
                          <option value="No1">Unknown/ No Response</option>
                        </Form.Select>
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.addressTypeDetailNewCase}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label="Street Address 1" required={isAddressRequired} />
                        <Form.Control
                          type="text"
                          name="street1"
                          value={selectedClient.street1 || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              street1: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          maxLength={100}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.street1}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label="Street Address 2" />
                        <Form.Control
                          type="text"
                          value={selectedClient.street2 || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              street2: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          maxLength={50}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="City" required={isAddressRequired} />
                        <Form.Control
                          name="city"
                          type="text"
                          value={selectedClient.city || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              city: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          maxLength={100}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.city}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"State"} required={isAddressRequired}></AppLabel>
                        <Form.Select
                          name="stateName"
                          value={selectedClient.stateName || ""} // Show the previous state
                          onChange={(e) => {
                            const newStateName = e.target.value;
                            const isFlorida = newStateName.toUpperCase() === "FLORIDA";
                            setSelectedClient({
                              ...selectedClient,
                              stateName: newStateName,
                              countyName: isFlorida ? selectedClient.countyName : "OUT OF STATE", // Set here
                            });
                          }}
                          disabled={!isEditable && !updatedEditable}
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state.id} value={state.value}>
                              {state.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.stateName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"County"} required={isAddressRequired}></AppLabel>
                        <Form.Select
                          name="countyName"
                          value={selectedClient.countyName || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              countyName: e.target.value,
                            })
                          }
                          disabled={(!isEditable && !updatedEditable) || selectedClient.stateName.toUpperCase() !== "FLORIDA"}
                        >
                          <option value="">Select County</option>
                          <option key={68} value="OUT OF STATE">
                            OUT OF STATE
                          </option>
                          {selectedClient.stateName.toUpperCase() === "FLORIDA" &&
                            counties.map((county) => (
                              <option key={county.id} value={county.value}>
                                {county.value}
                              </option>
                            ))}
                        </Form.Select>
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.countyName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Zip Code"} required={isAddressRequired} />
                        <Form.Control
                          type="text"
                          name="zipCode"
                          value={selectedClient.zipCode || ""}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setSelectedClient({
                              ...selectedClient,
                              zipCode: value,
                            });
                          }}
                          maxLength={10}
                          disabled={!isEditable && !updatedEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.zipCode}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Primary Phone" />
                        <Form.Control
                          type="text"
                          placeholder={
                            "10 digit phone number (ex: 555-555-5555)"
                          }
                          value={selectedClient.primaryPhone || ""}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const formattedPhoneNumber =
                              formatPhoneNumber(value);
                            setSelectedClient({
                              ...selectedClient,
                              primaryPhone: formattedPhoneNumber,
                            });
                          }}
                          disabled={!isEditable && !updatedEditable}
                        />
                      </Col>
                      <Col>
                        <AppLabel label="Secondary Phone" />
                        <Form.Control
                          type="text"
                          value={selectedClient.secondPhone || ""}
                          placeholder={
                            "10 digit phone number (ex: 555-555-5555)"
                          }
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const formattedPhoneNumber =
                              formatPhoneNumber(value);
                            setSelectedClient({
                              ...selectedClient,
                              secondPhone: formattedPhoneNumber,
                            });
                          }}
                          disabled={!isEditable && !updatedEditable}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Comments" />
                        <Form.Control
                          as="textarea"
                          value={selectedClient.comments || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              comments: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          maxLength={1500}
                          rows={2}
                        />
                        <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                          Character Count: {selectedClient.comments ? selectedClient.comments.length : 0} / 1500
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </AppCard>
                <AppCard title={
                  <div className="w-100" id="EmergencyContactInformation">
                    <div className="section-header">
                      <span className="section-title">
                        Emergency Contact Information
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Emergency Contact Name" />
                        <Form.Control
                          type="text"
                          value={selectedClient.erContactName || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              erContactName: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          maxLength={60}
                        />
                      </Col>
                      <Col>
                        <AppLabel label="Emergency Contact Relation" />
                        <Form.Select
                          value={selectedClient.relationshipId || ""}
                          onChange={(e) => {
                            const selectedOption = relationshipTypes.find(
                              (relationship) => relationship.id.toString() === e.target.value
                            );
                            setSelectedClient({
                              ...selectedClient,
                              relationshipId: selectedOption ? selectedOption.id : null, // Store the ID
                            });
                          }}
                          disabled={!isEditable && !updatedEditable}
                        >
                          <option value="">- - -</option> {/* Placeholder */}
                          {relationshipTypes.map((relationship) => (
                            <option key={relationship.id} value={relationship.id}>
                              {relationship.value}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <AppLabel label="Emergency Contact Phone" />
                        <Form.Control
                          type="text"
                          value={selectedClient.erContactPhone || ""}
                          onChange={(e) => {
                            const { value } = e.target; // Destructure value from event target
                            const formattedPhoneNumber = formatPhoneNumber(value); // Apply formatPhoneNumber
                            setSelectedClient({
                              ...selectedClient,
                              erContactPhone: formattedPhoneNumber, // Use the formatted value
                            });
                          }}
                          disabled={!isEditable && !updatedEditable}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </AppCard>

                {/* Section 2: Case Report Details */}
                <AppCard title={
                  <div className="w-100" id="MedicalInformation">
                    <div className="section-header">
                      <span className="section-title">
                        Medical Information
                      </span>

                      <span
                        onClick={toggleMedical}
                        className="section-toggle"
                      >
                        {isMedicalCollapsed ? "+" : "−"}
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  {!isMedicalCollapsed && (<Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Date Presented"} />
                        <Form.Control
                          {...register('datePresented')}
                          type="date"
                          value={
                            selectedClient.datePresented
                              ? new Date(selectedClient.datePresented)
                                .toISOString()
                                .split("T")[0]
                              : ""
                          }
                          onChange={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              datePresented: date
                            });
                            setValue('datePresented', date);
                          }}
                          onBlur={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              datePresented: date,
                            })
                            setValue('datePresented', date);
                          }}
                          max={maxDate}
                          min={minDate}
                          disabled={!isEditable && !updatedEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.datePresented}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Date Discharged"} />
                        <Form.Control
                          {...register('dateDischarged')}
                          type="date"
                          value={
                            selectedClient.dateDischarged
                              ? new Date(selectedClient.dateDischarged)
                                .toISOString()
                                .split("T")[0]
                              : ""
                          }
                          onChange={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dateDischarged: date,
                            })
                            setValue('dateDischarged', date);
                          }
                          }
                          onBlur={(e) => {
                            const date = adjustDateToMax(e.target.value, maxDate)
                            setSelectedClient({
                              ...selectedClient,
                              dateDischarged: date,
                            })
                            setValue('dateDischarged', date);
                          }}
                          max={maxDate}
                          min={minDate}
                          disabled={!isEditable && !updatedEditable}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.dateDischarged}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Chief Complaint"} />
                        <Form.Control
                          type="text"
                          name="chiefComplaint"
                          value={selectedClient.chiefComplaint || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              chiefComplaint: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                          maxLength={200}
                        />
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.chiefComplaint}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"List of Symptoms"} />
                        <Form.Control
                          as="textarea"
                          name="symptoms"
                          value={selectedClient.symptoms || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              symptoms: e.target.value,
                            })
                          }
                          disabled={!isEditable && !updatedEditable}
                          //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                          maxLength={1500}
                          rows={2}
                        />
                        <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                          Character Count: {selectedClient.symptoms ? selectedClient.symptoms.length : 0} / 1500
                        </div>
                        <div className="error m-0">
                          {updateCaseReportValidationErrors.symptoms}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label="Admitted to Hospital" />
                        <Form.Select
                          value={selectedClient.hospitalAdmit ? "1" : "0"}
                          name="hospitalAdmit"
                          onChange={(e) => {
                            const isAdmitted = e.target.value === "1";

                            setSelectedClient({
                              ...selectedClient,
                              hospitalAdmit: isAdmitted,
                            });

                            // update isEditable separately
                            // if (isAdmitted) {
                            //   setIsEditable(true);
                            // } else {
                            //   setIsEditable(false);
                            // }
                          }}
                          disabled={!isEditable && !updatedEditable}
                        //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </Form.Select>

                        <div className="error m-0">
                          {updateCaseReportValidationErrors.hospitalAdmit}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Where"} />
                        <Form.Control
                          type="text"
                          name="hospitalLocation"
                          value={selectedClient.hospitalLocation || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              hospitalLocation: e.target.value,
                            })
                          }
                          //disabled={(isAdmin ? !isAdmin : isFieldDisabled("hospitalLocation"))}
                          disabled={
                            !selectedClient.hospitalAdmit
                          }
                          maxLength={50}
                        />
                        <div className="error m-0">
                          {
                            updateCaseReportValidationErrors.hospitalLocation
                          }
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Hospital Room"} />
                        <Form.Control
                          type="text"
                          name="hospitalLocation"
                          value={selectedClient.hospitalRoom || ""}
                          onChange={(e) =>
                            setSelectedClient({
                              ...selectedClient,
                              hospitalRoom: e.target.value,
                            })
                          }
                          disabled={
                            !selectedClient.hospitalAdmit
                          }
                          maxLength={25}
                        />
                        <div className="error m-0">
                          {
                            updateCaseReportValidationErrors.hospitalLocation
                          }
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>)}
                </AppCard>

                {/* Linkage to Care for DW Client */}
                {selectedClient?.sourceName != "FLCareLookUp" && (
                  <AppCard title={
                    <div className="w-100" id="LinkageToCareStatus">
                      <div className="section-header">
                        <span className="section-title">
                          Linkage to Care Status
                        </span>
                      </div>
                    </div>
                  } bottomMargin>
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label="Linkage to Care Status" />
                          <Form.Select
                            //{...register("LinkageCareStatus")}
                            name="LinkageCareStatusId"
                            value={selectedClient.linkageToCareStatusForHivDiagnosis || ""}
                            onChange={(e) =>
                              setSelectedClient({
                                ...selectedClient,
                                linkageToCareStatusForHivDiagnosis: e.target.value,
                              })
                            }
                            disabled
                          //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                          >
                            {allLinkageCareStatusesData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col>
                          <AppLabel label={"Updated Linkage to Care Status"} />
                          <Form.Select
                            //{...register("LinkageCareStatus")}
                            name="LinkageCareStatusId"
                            value={selectedClient.linkageCareStatusId || ""}
                            onChange={(e) => {
                              setSelectedClient({
                                ...selectedClient,
                                linkageCareStatusId: e.target.value,
                              });
                              handleSectionValidation(false, false, true);
                            }}
                            disabled={!isEditable && !updatedEditable}
                          //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                          >
                            {allLinkageCareStatusesData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        {String(selectedClient?.linkageCareStatusId ?? "") === "7" && ( // linkageCareStatusId 7 is "Others"
                          <Col>
                            <AppLabel label={"Details"} />
                            <Form.Control
                              type="text"
                              value={selectedClient.linkageCareStatusOtherDetails || ""}
                              onChange={(e) => {
                                setSelectedClient({
                                  ...selectedClient,
                                  linkageCareStatusOtherDetails: e.target.value,
                                });
                              }}
                              maxLength={50}
                              disabled={!isEditable && !updatedEditable}
                            />
                          </Col>
                        )}
                        {String(selectedClient?.linkageCareStatusId ?? "") !== "7" && (  // linkageCareStatusId 7 is "Others"
                          <Col>
                          </Col>
                        )}

                      </Row>

                    </Card.Body>
                  </AppCard>
                )}

                {/* Linkage to Care for New Client */}
                {selectedClient?.sourceName == "FLCareLookUp" && (
                  <AppCard title={
                    <div className="w-100" id="LinkageToCareStatus">
                      <div className="section-header">
                        <span className="section-title">
                          Linkage to Care Status
                        </span>
                      </div>
                    </div>
                  } bottomMargin>
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"Updated Linkage Care Status"} />
                          <Form.Select
                            //{...register("LinkageCareStatus")}
                            name="LinkageCareStatusId"
                            value={selectedClient.linkageCareStatusId || ""}
                            onChange={(e) => {
                              if (e.target.selectedOptions[0].text === 'Others') {
                                setSelectedClient({
                                  ...selectedClient,
                                  linkageCareStatusId: e.target.value,
                                });
                              } else { // if not "Other" then clear the other details
                                setSelectedClient({
                                  ...selectedClient,
                                  linkageCareStatusId: e.target.value,
                                  linkageCareStatusOtherDetails: "",
                                });
                              }
                              handleSectionValidation(false, false, true);
                            }}
                            disabled={type === "Updated" || type === "View"}
                          >
                            {allLinkageCareStatusesData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        {String(selectedClient?.linkageCareStatusId ?? "") === "7" && ( // linkageCareStatusId 7 is "Others"
                          <Col>
                            <AppLabel label={"Details"} />
                            <Form.Control
                              type="text"
                              value={selectedClient.linkageCareStatusOtherDetails || ""}
                              onChange={(e) => {
                                setSelectedClient({
                                  ...selectedClient,
                                  linkageCareStatusOtherDetails: e.target.value,
                                });
                              }}
                              maxLength={50}
                              disabled={type === "Updated" || type === "View"}
                            />
                          </Col>
                        )}
                        {String(selectedClient?.linkageCareStatusId ?? "") !== "7" && (  // linkageCareStatusId 7 is "Others"
                          <Col>
                          </Col>
                        )}
                        <Col>
                        </Col>
                      </Row>
                    </Card.Body>
                  </AppCard>
                )}

                {!isSTDProvider &&
                  <div>

                    {/* Section 3: Additional Details */}
                    {/* Testing Information */}
                    <AppCard titleNode={handleTestingInformationTitle} hasTitleNode bottomMargin>
                      <div id="TestingInformation"></div>
                      {!isTestingInfoCollapsed && (
                        <Card.Body>
                          <Row className="mb-3">
                            <Col>
                              <input type='hidden' name='updatedEditable' value={updatedEditable.toString()}></input>
                              <AppLabel label="NAAT"
  required={
    selectedClient?.isPositiveTest === true &&
    selectedClient?.isCaseReport === false
  } />
                              <Form.Select
                                {...register('naat')}
                                value={selectedClient.naat || ""}
                                name="naat"
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    naat: e.target.value,
                                  });
                                   setupdateCaseReportValidationErrors((prev: any) => ({
    ...prev,
    naat: "",
  }));
                                  handleSectionValidation(true, false, false);
                                  if (e.target.value && e.target.value !== '0') {
                                    isPositiveTestRef.current.naat = false;
                                  } else {
                                    isPositiveTestRef.current.naat = true;
                                  }
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                              //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                                <option value="Indetermine">Indetermine</option>
                                <option value="Notperformed">Not Performed</option>
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.naat}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"NAAT Date"} required={selectedClient.naat == "Positive"}></AppLabel>
                              <Form.Control
                                {...register("naatDate")}
                                name="naatDate"
                                type="date"
                                value={
                                  selectedClient.naatdate
                                    ? selectedClient.naatdate.split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    naatdate: date
                                  })
                                  setValue('naatDate', date)
                                  handleSectionValidation(true, false, false);
                                  handleFormFieldChange(e);
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                min={minDate}
                                max={maxDate} // Set the max attribute to today
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.naatDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label="Disclosed" />
                              <Form.Select
                                {...register('disclosed')}
                                value={selectedClient.disclosed || ""}
                                name="disclosed"
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    disclosed: e.target.value,
                                  })
                                  handleSectionValidation(true, false, false);
                                  if (e.target.value && e.target.value !== '0') {
                                    isPositiveTestRef.current.disclosed = false;
                                  } else {
                                    isPositiveTestRef.current.disclosed = true;
                                  }
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                              //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                              >
                                <option value="0">--</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.disclosed}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Disclosed Date"} required={selectedClient.disclosed == "Yes"}></AppLabel>
                              <Form.Control
                                {...register('disclosedDate')}
                                name="disclosedDate"
                                type="date"
                                value={
                                  selectedClient.disclosedDate
                                    ? new Date(selectedClient.disclosedDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    disclosedDate: e.target.value,
                                  })
                                  handleSectionValidation(true, false, false);
                                  setValue('disclosedDate', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    disclosedDate: date,
                                  });
                                  setValue('disclosedDate', date);
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                min={minDate}
                                max={maxDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.disclosedDate}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label="HIV Ag/Ab" />
                              <Form.Select
                                {...register('hivAgAb')}
                                value={selectedClient.hivAgAb || ""}
                                name="hivAgAb"
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivAgAb: e.target.value,
                                  })
                                  handleSectionValidation(false, true, false);
                                  if (e.target.value && e.target.value !== '0') {
                                    isPositiveTestRef.current.hivagab = false;
                                  } else {
                                    isPositiveTestRef.current.hivagab = true;
                                  }
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                              //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                                <option value="Indetermine">Indetermine</option>
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.hivAgAb}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"HIV-1/2 Ag/Ab Date"} required={selectedClient.hivAgAb == "Positive"}></AppLabel>
                              <Form.Control
                                {...register("hivAgAbDate")}
                                name="hivAgAbDate"
                                type="date"
                                value={
                                  selectedClient.hivAgAbDate
                                    ? new Date(selectedClient.hivAgAbDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivAgAbDate: date
                                  })
                                  setValue('hivAgAbDate', date);
                                  handleSectionValidation(false, true, false);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivAgAbDate: date,
                                  });
                                  setValue('hivAgAbDate', date);
                                  handleSectionValidation(false, true, false);
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.hivAgAbDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label="In Care" />
                              <Form.Select
                                {...register('inCare')}
                                value={selectedClient.inCare || ""}
                                name="inCare"
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    inCare: e.target.value,
                                  })
                                  handleSectionValidation(false, true, false);
                                  if (e.target.value && e.target.value !== '0') {
                                    isPositiveTestRef.current.incare = false;
                                  } else {
                                    isPositiveTestRef.current.incare = true;
                                  }
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                              //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                              >
                                <option value="0">--</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.inCare}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"In Care Date"} required={selectedClient.inCare == "Yes"}></AppLabel>
                              <Form.Control
                                {...register('inCareDate')}
                                name="inCareDate"
                                type="date"
                                value={
                                  selectedClient.inCareDate
                                    ? new Date(selectedClient.inCareDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    inCareDate: date
                                  })
                                  setValue('inCareDate', date)
                                  handleSectionValidation(false, true, false);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    inCareDate: date,
                                  });
                                  setValue('inCareDate', date)
                                  handleSectionValidation(false, true, false);
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.inCareDate}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label="HIV IA (Supplemental)" />
                              <Form.Select
                                {...register("hivIa")}
                                value={selectedClient.hivIa || ""}
                                name="hivIa"
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivIa: e.target.value,
                                  })
                                  handleSectionValidation(false, false, true);
                                  if (e.target.value && e.target.value !== '0') {
                                    isPositiveTestRef.current.hivIa = false;
                                  } else {
                                    isPositiveTestRef.current.hivIa = true;
                                  }
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                              //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                                <option value="Indetermine">Indetermine</option>
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.hivIa}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={"HIV - 1/2 IA (Supplemental) Date"}
                                required={selectedClient.hivIa == "Positive"}
                              ></AppLabel>
                              <Form.Control
                                {...register("hivIaSupplementalDate")}
                                name="hivIaSupplementalDate"
                                type="date"
                                value={
                                  selectedClient.hivIaDate
                                    ? new Date(selectedClient.hivIaDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivIaDate: date
                                  })
                                  setValue('hivIaSupplementalDate', date);
                                  handleSectionValidation(false, false, true);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivIaDate: date,
                                  });
                                  setValue('hivIaSupplementalDate', date);
                                }}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.hivIaSupplementalDate}
                              </div>
                            </Col>
                            <Col>

                            </Col>
                            <Col></Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label="Medication" />
                              <Form.Control
                                type="text"
                                value={selectedClient.medication || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    medication: e.target.value,
                                  })
                                }
                                disabled={(!isEditable && !updatedEditable) || selectedClient.isCaseReport}
                                //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                                maxLength={200}
                              />
                            </Col>
                          </Row>
                        </Card.Body>
                      )}
                    </AppCard>
                  </div>
                }

                {!isSTDProvider &&
                  <div>

                    {/* Section 3: Additional Details */}
                    <AppCard title={
                      <div className="w-100" id="HIVDetails">
                        <div className="section-header">
                          <span className="section-title">
                            HIV Diagnosis Details
                          </span>

                          <span
                            onClick={toggleHiv}
                            className="section-toggle"
                          >
                            {isHivCollapsed ? "+" : "−"}
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      {!isHivCollapsed && (
                        <Card.Body>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label="HIV Diagnosis Date" />
                              <Form.Control
                                {...register('hivDiagnosisDate')}
                                type="date"
                                value={
                                  selectedClient?.hivdateofDiagnosis?.split("T")[0]
                                }
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivdateofDiagnosis: e.target.value,
                                    dateLabs: e.target.value,
                                  })
                                  setValue('hivDiagnosisDate', e.target.value)
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivdateofDiagnosis: date,
                                    dateLabs: date,
                                  });
                                  setValue('hivDiagnosisDate', e.target.value)
                                }}
                                max={maxDate}
                                min={minDate}
                                disabled={type === "Updated" || type === "View"}
                              //disabled={!isEditable && !updatedEditable}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.hivDiagnosisDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"AIDS Date"} />
                              <Form.Control
                                {...register('aidsDate')}
                                type="date"
                                value={selectedClient?.aidsDate}
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    aidsDate: date,
                                  });
                                  setValue('aidsDate', date)
                                }
                                }
                                disabled={type === "Updated" || type === "View"}
                                //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                                readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.aidsDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Mode of Transmission"} />
                              <Form.Select
                                name="clientInfoHIVModeOfTransmissionId"
                                value={selectedClient?.hivmodeOfTransmissionId}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivmodeOfTransmissionId: e.target.value,
                                  })
                                }
                                disabled={type === "Updated" || type === "View"}
                              //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              >
                                {allModeoftransmissionData.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label={"Date Reported HIV Positive to State"} />
                              <Form.Control
                                {...register('dateReportedHivPositive')}
                                type="date"
                                value={selectedClient?.hivReportedDate}
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    hivReportedDate: date,
                                  })
                                  setValue('dateReportedHivPositive', date);
                                }
                                }
                                disabled={type === "Updated" || type === "View"}
                                //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.dateReportedHivPositive}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label="Date of Last Viral Load" required />
                              <Form.Control
                                {...register('lastViralLoad')}
                                type="date"
                                value={selectedClient?.last_viral_load_date?.split('T')[0]}
                                disabled={type === "Updated" || type === "View"}
                                //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    last_viral_load_date: e.target.value,
                                  });
                                  setValue('lastViralLoad', e.target.value);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.lastViralLoad}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Viral Load"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.viralLoad || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    viralLoad: e.target.value,
                                  })
                                }
                                maxLength={25}
                                disabled={type === "Updated" || type === "View"}
                              //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            {/* <Col>
                              <AppLabel label="Linkage to Care Status" />
                              <Form.Select
                                //{...register("LinkageCareStatus")}
                                name="LinkageCareStatusId"
                                value={selectedClient.linkageToCareStatusForHivDiagnosis || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    linkageToCareStatusForHivDiagnosis: e.target.value,
                                  })
                                }
                                disabled={type === "Updated" || type === "View"}
                              //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                              >
                                {allLinkageCareStatusesData.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col> */}
                            <Col>
                              <AppLabel label="Date of Last CD4 Count" required />
                              <Form.Control
                                {...register('lastCd4')}
                                type="date"
                                value={selectedClient?.last_cd4_count_date?.split('T')[0]}
                                disabled={type === "Updated" || type === "View"}
                                //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    last_cd4_count_date: e.target.value,
                                  });
                                  setValue('lastCd4', e.target.value)
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.lastCd4}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label="CD4 Count" />
                              <Form.Control
                                type="text"
                                value={selectedClient.cd4count || ""}
                                onChange={(e) => {
                                  let cd4Count = e.target.value;
                                  if (cd4Count.length > 10) {
                                    cd4Count = cd4Count.substring(0, 10);
                                  }
                                  setSelectedClient({
                                    ...selectedClient,
                                    cd4count: cd4Count,
                                  })
                                }
                                }
                                maxLength={25}
                                disabled={type === "Updated" || type === "View"}
                              //disabled={type === "Updated" || (!isAdmin && !isEditable)}
                              />
                            </Col>
                            <Col></Col>
                          </Row>

                        </Card.Body>
                      )}
                    </AppCard>
                    {type !== "" && (selectedClient?.sourceName != "FLCareLookUp") && (
                      <AppCard title={
                        <div className="w-100" id="UpdatedHIVDetails">
                          <div className="section-header">
                            <span className="section-title">
                              Updated HIV Diagnosis Details
                            </span>

                            <span
                              onClick={toggleUpdatedHiv}
                              className="section-toggle"
                            >
                              {isUpdatedHivCollapsed ? "+" : "−"}
                            </span>
                          </div>
                        </div>
                      } bottomMargin>
                        {!isUpdatedHivCollapsed && (
                          <Card.Body>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"HIV Diagnosis Date"} />
                                <Form.Control
                                  {...register('updatedHivdateofDiagnosis')}
                                  type="date"
                                  value={selectedClient?.updatedHIVDateofDiagnosis?.split('T')[0]}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedHIVDateofDiagnosis: date,
                                    });
                                    setValue('updatedHivdateofDiagnosis', date);
                                  }
                                  }
                                  disabled={!isEditable && !updatedEditable}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.updatedHivdateofDiagnosis}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"AIDS Date"} />
                                <Form.Control
                                  {...register('updatedAidsDate')}
                                  type="date"
                                  value={selectedClient?.updatedAidsDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedAidsDate: date,
                                    });
                                    setValue('updatedAidsDate', date)
                                  }}
                                  disabled={!isEditable && !updatedEditable}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.updatedAidsDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Mode of Transmission"} />
                                <Form.Select
                                  name="updatedClientInfoHIVModeOfTransmissionId"
                                  value={selectedClient?.updatedHivmodeOfTransmissionId}
                                  onChange={(e) =>
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedHivmodeOfTransmissionId: e.target.value,
                                    })
                                  }
                                  disabled={!isEditable && !updatedEditable}
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                >
                                  {allModeoftransmissionData.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"Date Reported HIV Positive to State"} />
                                <Form.Control
                                  {...register('updatedDateReportedHivPositive')}
                                  type="date"
                                  value={selectedClient?.updatedHivReportedDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedHivReportedDate: date,
                                    })
                                    setValue('updatedDateReportedHivPositive', date);
                                  }}
                                  disabled={!isEditable && !updatedEditable}
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.updatedDateReportedHivPositive}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Date of Last Viral Load"
                                  }
                                  required
                                />
                                <Form.Control
                                  {...register("updatedLastViralLoad")}
                                  name="updatedLastViralLoad"
                                  type="date"
                                  value={selectedClient?.updatedlast_viral_load_date?.split('T')[0]}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedlast_viral_load_date: date,
                                    });
                                    //setUpdatedLastUpdatedDate((prev) => ({ ...prev, lastViralLoad: date }));
                                    setValue('updatedLastViralLoad', date);
                                  }}
                                  disabled={!isEditable && !updatedEditable}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                >
                                </Form.Control>
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.updatedLastViralLoad}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Viral Load"} />
                                <Form.Control
                                  type="text"
                                  value={selectedClient?.updatedViralLoad}
                                  onChange={(e) =>
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedViralLoad: e.target.value,
                                    })
                                  }
                                  maxLength={25}
                                  disabled={!isEditable && !updatedEditable}
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              {/* <Col>
                                <AppLabel label={"Linkage to Care Status"} />
                                <Form.Select
                                  name="UpdatedLinkageToCareStatusId"
                                  value={selectedClient?.updatedLinkageToCareStatusForHivDiagnosis}
                                  onChange={(e) =>
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedLinkageToCareStatusForHivDiagnosis: e.target.value,
                                    })
                                  }
                                  disabled={!isEditable && !updatedEditable}
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                >
                                  {allLinkageCareStatusesData.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col> */}
                              <Col>
                                <AppLabel
                                  label="Date of Last CD4 Count"
                                  required
                                />
                                <Form.Control
                                  {...register('updatedlastCd4')}
                                  type="date"
                                  value={selectedClient?.updatedlast_cd4_count_date?.split('T')[0]}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedlast_cd4_count_date: date,
                                    });
                                    //setUpdatedLastUpdatedDate((prev) => ({ ...prev, lastCd4: date }));
                                    setValue('updatedlastCd4', date);
                                  }
                                  }
                                  disabled={!isEditable && !updatedEditable}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.updatedlastCd4}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"CD4 Count"} />
                                <Form.Control
                                  type="text"
                                  value={selectedClient?.updatedCD4Count}
                                  disabled={!isEditable && !updatedEditable}
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  //onChange={(e) => setUpdatedClientInfoCD4Count(e.target.value)}
                                  onChange={(e) =>
                                    setSelectedClient({
                                      ...selectedClient,
                                      updatedCD4Count: e.target.value,
                                    })
                                  }
                                  maxLength={25}
                                />
                              </Col>
                              <Col></Col>
                            </Row>
                          </Card.Body>
                        )}
                      </AppCard>
                    )}

                  </div>
                }

                {
                  !showStdTestInfo && selectedClient?.sourceName == "FLCareLookUp" && (
                    <AppCard title={
                      <div className="w-100" id="STDTestInformation">
                        <div className="section-header">
                          <span className="section-title">
                            STD Test Information
                          </span>

                          <span
                            onClick={toggleStdInfo}
                            className="section-toggle"
                          >
                            {isStdInfoCollapsed ? "+" : "−"}
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      {!isStdInfoCollapsed && (
                        <Card.Body>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px"
                            }} label={"RPR Test Information"} />
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register('rPRType')}
                                name="rPRType"
                                value={selectedClient.rpR_Type || ""}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { rpR_Specimen_Collection_Date: any; rpR_Result: any; rpR_Specimen_ID: any; rpR_Titer: any; }) => ({
                                    ...prev,
                                    rpR_Type: newType,
                                    rpR_Specimen_Collection_Date: newType ? prev.rpR_Specimen_Collection_Date : "", // Clear date if type empty
                                    rpR_Result: newType ? prev.rpR_Result : "", // Clear result if type empty
                                    rpR_Specimen_ID: newType ? prev.rpR_Specimen_ID : "",
                                    rpR_Titer: newType ? prev.rpR_Titer : "",
                                  }));

                                  setValue('rPRType', newType);
                                  if (!newType) {
                                    setValue('rprCollectionDate', "");
                                    setValue('rpR_Result', "");
                                    // setValue('rprSpecimenID', "");
                                    // setValue('rpR_Titer', "");

                                  }
                                }}
                              >
                                <option value="">Select Test Type</option>
                                {caseReportTestData
                                  .filter(option => option.value === 'RPR')
                                  .map(option => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>

                            </Col>

                            <Col>
                              <AppLabel label={"Specimen Collection Date"}
                                required={selectedClient.rpR_Type !== null && selectedClient.rpR_Type !== ""}
                              />
                              <Form.Control
                                {...register('rprCollectionDate')}
                                type="date"
                                name="rprCollectionDate"
                                value={
                                  selectedClient.rpR_Specimen_Collection_Date
                                    ? new Date(selectedClient.rpR_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    rpR_Specimen_Collection_Date: date
                                  })
                                  setValue('rprCollectionDate', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    rpR_Specimen_Collection_Date: date,
                                  });
                                  setValue('rprCollectionDate', date)
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={(isAdmin ? !isAdmin : !isEditable || isChecked) && !isHivProvider}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.rpR_Type}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.rprCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="rprSpecimenID"
                                type="text"
                                value={selectedClient.rpR_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, rpR_Specimen_ID: e.target.value })}
                                //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.rpR_Type}
                                maxLength={25}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.rprSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.rpR_Type !== null && selectedClient.rpR_Type !== ""}
                              />
                              <Form.Select
                                {...register('rpR_Result')}
                                name="rpR_Result"
                                value={selectedClient.rpR_Result || ""}
                                onChange={(e) => {
                                  const newResult = e.target.value;
                                  const shouldClearTiter = newResult === "" || newResult === "6"; //  "6" is Non-Reactive
                                  setSelectedClient((prev: { rpR_Titer: any; }) => ({
                                    ...prev,
                                    rpR_Result: newResult,
                                    rpR_Titer: shouldClearTiter ? "" : prev.rpR_Titer,
                                  }));
                                  handleFormFieldChange(e);

                                }}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.rpR_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {
                                  updateCaseReportValidationErrors.rpR_Result
                                }
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Titer"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.rpR_Titer}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || selectedClient.rpR_Result !== '5'} //5=Reactive
                                onChange={(e) => setSelectedClient({ ...selectedClient, rpR_Titer: e.target.value })}
                                maxLength={10}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"CSF-VDRL Test Information"}
                            />
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register('vDRLType')}
                                name="vDRLType"
                                value={selectedClient.vdrL_Type || ""} // Ensure value stores ID
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { vdrL_Specimen_Collection_Date: any; vdrL_Result: any; vdrL_Specimen_ID: any; vdrL_Titer: any; }) => ({
                                    ...prev,
                                    vdrL_Type: newType,
                                    vdrL_Specimen_Collection_Date: newType ? prev.vdrL_Specimen_Collection_Date : "", // Clear date if type empty
                                    vdrL_Result: newType ? prev.vdrL_Result : "", // Clear result if type empty
                                    vdrL_Specimen_ID: newType ? prev.vdrL_Specimen_ID : "",
                                    vdrL_Titer: newType ? prev.vdrL_Titer : "",
                                  }));

                                  setValue('vDRLType', newType);
                                  if (!newType) {
                                    setValue('vdrlCollectionDate', "");
                                    setValue('vdrL_Result', "");
                                  }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'VDRL')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"}
                                required={selectedClient.vdrL_Type !== null && selectedClient.vdrL_Type !== ""}
                              />
                              <Form.Control
                                {...register('vdrlCollectionDate')}
                                type="date"
                                name="vdrlCollectionDate"
                                value={
                                  selectedClient.vdrL_Specimen_Collection_Date
                                    ? new Date(selectedClient.vdrL_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    vdrL_Specimen_Collection_Date: date
                                  });
                                  setValue('vdrlCollectionDate', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    vdrL_Specimen_Collection_Date: date,
                                  });
                                  setValue('vdrlCollectionDate', date)
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.vdrL_Type}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.vdrlCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="vdrlSpecimenID"
                                type="text"
                                value={selectedClient.vdrL_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, vdrL_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.vdrL_Type}
                                maxLength={25}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.vdrlSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.vdrL_Type !== null && selectedClient.vdrL_Type !== ""}
                              />
                              <Form.Select
                                {...register('vdrL_Result')}
                                value={selectedClient.vdrL_Result || ""}
                                name="vdrL_Result"
                                onChange={(e) => {
                                  const newResult = e.target.value;
                                  const shouldClearTiter = newResult === "" || newResult === "6"; //  "6" is Non-Reactive
                                  setSelectedClient((prev: { vdrL_Titer: any; }) => ({
                                    ...prev,
                                    vdrL_Result: newResult,
                                    vdrL_Titer: shouldClearTiter ? "" : prev.vdrL_Titer,
                                  }));
                                  handleFormFieldChange(e);

                                }}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.vdrL_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.vdrL_Result}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Titer"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.vdrL_Titer}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || selectedClient.vdrL_Result !== '5'}
                                onChange={(e) => setSelectedClient({ ...selectedClient, vdrL_Titer: e.target.value })}
                                maxLength={10}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"TP-PA Information"} />
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register('tPPAType')}
                                value={selectedClient.tppA_Type || ""} // Ensure value stores ID
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { tppA_Specimen_Collection_Date: any; tppA_Result: any; }) => ({
                                    ...prev,
                                    tppA_Type: newType,
                                    tppA_Specimen_Collection_Date: newType ? prev.tppA_Specimen_Collection_Date : "", // Clear date if type empty
                                    tppA_Result: newType ? prev.tppA_Result : "", // Clear result if type empty
                                  }));

                                  setValue('tPPAType', newType);
                                  if (!newType) {
                                    setValue('tppaCollectionDate', "");
                                    setValue('tppA_Result', "");
                                  }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'TP-PA')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"}
                                required={selectedClient.tppA_Type !== null && selectedClient.tppA_Type !== ""}
                              />
                              <Form.Control
                                {...register('tppaCollectionDate')}
                                type="date"
                                name="tppaCollectionDate"
                                value={
                                  selectedClient.tppA_Specimen_Collection_Date
                                    ? new Date(selectedClient.tppA_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Specimen_Collection_Date: date
                                  })
                                  setValue('tppaCollectionDate', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Specimen_Collection_Date: date,
                                  });
                                  setValue('tppaCollectionDate', date);
                                }}
                                min={minDate}
                                max={maxDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.tppA_Type}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.tppaCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="tppaSpecimenID"
                                type="text"
                                value={selectedClient.tppA_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, tppA_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.tppA_Type}
                                maxLength={25}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.tppaSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.tppA_Type !== null && selectedClient.tppA_Type !== ""}
                              />
                              <Form.Select
                                {...register('tppA_Result')}
                                value={selectedClient.tppA_Result || ""}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Result: e.target.value,
                                  });
                                  handleFormFieldChange(e);
                                }}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.tppA_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {
                                  updateCaseReportValidationErrors.tppA_Result
                                }
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"FTA-ABS Information "} />
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register('fTAABSType')}
                                value={selectedClient.ftaabS_Type || ""} // Ensure value stores ID
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { ftA_ABS_Specimen_Collection_Date: any; ftaabS_Result: any; }) => ({
                                    ...prev,
                                    ftaabS_Type: newType,
                                    ftA_ABS_Specimen_Collection_Date: newType ? prev.ftA_ABS_Specimen_Collection_Date : "", // Clear date if type empty
                                    ftaabS_Result: newType ? prev.ftaabS_Result : "", // Clear result if type empty
                                  }));

                                  setValue('fTAABSType', newType);
                                  if (!newType) {
                                    setValue('ftA_ABS_Specimen_Collection_Date', "");
                                    setValue('ftaabS_Result', "");
                                  }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'FTA-ABS')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"}
                                required={selectedClient.ftaabS_Type !== null && selectedClient.ftaabS_Type !== ""}
                              />
                              <Form.Control
                                {...register('ftA_ABS_Specimen_Collection_Date')}
                                type="date"
                                name="ftA_ABS_Specimen_Collection_Date"
                                value={
                                  selectedClient.ftA_ABS_Specimen_Collection_Date
                                    ? new Date(selectedClient.ftA_ABS_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftA_ABS_Specimen_Collection_Date: e.target.value,
                                  })
                                  setValue('ftA_ABS_Specimen_Collection_Date', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftA_ABS_Specimen_Collection_Date: date,
                                  });
                                  setValue('ftA_ABS_Specimen_Collection_Date', date);
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.ftaabS_Type}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.ftA_ABS_Specimen_Collection_Date}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="ftaABSSpecimenID"
                                type="text"
                                value={selectedClient.ftA_ABS_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, ftA_ABS_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.ftaabS_Type}
                                maxLength={25}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.ftaabsSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.ftaabS_Type !== null && selectedClient.ftaabS_Type !== ""}
                              />
                              <Form.Select
                                {...register('ftaabS_Result')}
                                value={selectedClient.ftaabS_Result || ""}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftaabS_Result: e.target.value,
                                  });
                                  handleFormFieldChange(e);
                                }}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.ftaabS_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.ftaabS_Result}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <AppLabel
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }}
                              label={"EIA Information"}
                            />

                            {/* TEST TYPE */}
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register("eIAIgG_Type")}
                                value={selectedClient.eiaIgG_Type || ""}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: any) => ({
                                    ...prev,
                                    eiaIgG_Type: newType,
                                    eiA_IgG_Specimen_Collection_Date: newType
                                      ? prev.eiA_IgG_Specimen_Collection_Date
                                      : "",
                                    eiaIgG_Result: newType ? prev.eiaIgG_Result : "",
                                  }));

                                  setValue("eIAIgG_Type", newType);

                                  if (!newType) {
                                    setValue("eIAIgGSpecimenCollectionDate", "");
                                    setValue("eIAIgG_Result", "");
                                  }
                                }}
                              >
                                <option value="">Select Test Type</option>
                                {caseReportTestData
                                  .filter((option) => option.value === "EIA")
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>

                            {/* SPECIMEN COLLECTION DATE */}
                            <Col>
                              <AppLabel
                                label={"Specimen Collection Date"}
                                required={
                                  selectedClient.eiaIgG_Type !== null &&
                                  selectedClient.eiaIgG_Type !== ""
                                }
                              />

                              <Form.Control
                                {...register("eIAIgGSpecimenCollectionDate")}
                                type="date"
                                name="eIAIgGSpecimenCollectionDate"
                                value={
                                  selectedClient.eiA_IgG_Specimen_Collection_Date
                                    ? new Date(
                                      selectedClient.eiA_IgG_Specimen_Collection_Date
                                    )
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(e.target.value, maxDate);

                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_Collection_Date: e.target.value,
                                  });

                                  setValue("eIAIgGSpecimenCollectionDate", date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(e.target.value, maxDate);

                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_Collection_Date: date,
                                  });

                                  setValue("eIAIgGSpecimenCollectionDate", date);
                                }}
                                max={maxDate}
                                min={minDate}
                                disabled={
                                  type === "Updated" ||
                                  type === "View" ||
                                  !selectedClient.eiaIgG_Type
                                }
                              />

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgGSpecimenCollectionDate}
                              </div>
                            </Col>


                            {/* SPECIMEN ID */}
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="eIAIgGSpecimenID"
                                type="text"
                                value={selectedClient.eiA_IgG_Specimen_ID || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_ID: e.target.value,
                                  })
                                }
                                disabled={
                                  type === "Updated" ||
                                  type === "View" ||
                                  !selectedClient.eiaIgG_Type
                                }
                                maxLength={15}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgGSpecimenId}
                              </div>
                            </Col>

                            {/* DETAILS */}
                            <Col>
                              <AppLabel
                                label={"Details"}
                                required={
                                  selectedClient.eiaIgG_Type !== null &&
                                  selectedClient.eiaIgG_Type !== ""
                                }
                              />
                              <Form.Select
                                {...register("eIAIgG_Result")}
                                value={selectedClient.eiaIgG_Result || ""}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    eiaIgG_Result: e.target.value,
                                  });
                                  handleFormFieldChange(e);
                                }}
                                disabled={
                                  type === "Updated" ||
                                  type === "View" ||
                                  !selectedClient.eiaIgG_Type
                                }
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter(
                                    (option) =>
                                      option.value === "Reactive" ||
                                      option.value === "Non-Reactive"
                                  )
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgG_Result}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"Chlamydia [200] Test Information "} />
                            <Col>
                              <AppLabel label={"Test Type"} />
                              <Form.Select
                                {...register('chlamydia_Type')}
                                value={selectedClient.chlamydia_Type || ""} // Ensure value stores ID
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { chlamydiaDate: any; chlamydia_Result: any; }) => ({
                                    ...prev,
                                    chlamydia_Type: newType,
                                    chlamydiaDate: newType ? prev.chlamydiaDate : "", // Clear date if type empty
                                    chlamydia_Result: newType ? prev.chlamydia_Result : "", // Clear result if type empty
                                  }));

                                  setValue('chlamydia_Type', newType);
                                  if (!newType) {
                                    setValue('chlamydiaDate', "");
                                    setValue('chlamydia_Result', "");
                                  }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'Chlamydia')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"}
                                required={selectedClient.chlamydia_Type !== null && selectedClient.chlamydia_Type !== ""}
                              />
                              <Form.Control
                                {...register('chlamydiaDate')}
                                type="date"
                                name="chlamydiaDate"
                                value={
                                  selectedClient.chlamydiaDate
                                    ? new Date(selectedClient.chlamydiaDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydiaDate: date
                                  })
                                  setValue('chlamydiaDate', date);
                                  handleFormFieldChange(e);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydiaDate: date,
                                  });
                                  setValue('chlamydiaDate', date)
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.chlamydia_Type}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.chlamydiaDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="chlamydiaSpecimenID"
                                type="text"
                                value={selectedClient.chlamydia_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, chlamydia_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.chlamydia_Type}
                                maxLength={25}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.chlamydiaSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.chlamydia_Type !== null && selectedClient.chlamydia_Type !== ""}
                              />
                              <Form.Select
                                {...register('chlamydia_Result')}
                                name="chlamydia_Result"
                                value={selectedClient.chlamydia_Result || ""}
                                onChange={(e) => {
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydia_Result: e.target.value,
                                  });
                                  handleFormFieldChange(e);
                                }}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View" || !selectedClient.chlamydia_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.chlamydia_Result}
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      )}
                      {!isStdInfoCollapsed && (
                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                            marginTop: "10px"
                          }} label={"Gonorrhea [300] Test Information "} />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register('gonorrhea_Type')}
                              value={selectedClient.gonorrhea_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const newType = e.target.value;

                                setSelectedClient((prev: { gonorrhea_Specimen_Collection_Date: any; gonorrhea_Result: any; }) => ({
                                  ...prev,
                                  gonorrhea_Type: newType,
                                  gonorrhea_Specimen_Collection_Date: newType ? prev.gonorrhea_Specimen_Collection_Date : "", // Clear date if type empty
                                  gonorrhea_Result: newType ? prev.gonorrhea_Result : "", // Clear result if type empty
                                }));

                                setValue('gonorrhea_Type', newType);
                                if (!newType) {
                                  setValue('gonorrhea_Specimen_Collection_Date', "");
                                  setValue('gonorrhea_Result', "");
                                }
                              }}
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'Gonorrhea')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={selectedClient.gonorrhea_Type !== null && selectedClient.gonorrhea_Type !== ''}
                            />
                            <Form.Control
                              {...register('gonorrhea_Specimen_Collection_Date')}
                              type="date"
                              name="gonorrhea_Specimen_Collection_Date"
                              value={
                                selectedClient.gonorrhea_Specimen_Collection_Date
                                  ? new Date(selectedClient.gonorrhea_Specimen_Collection_Date)
                                    .toISOString()
                                    .split("T")[0]
                                  : ""
                              }
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setSelectedClient({
                                  ...selectedClient,
                                  gonorrhea_Specimen_Collection_Date: date
                                })
                                setValue('gonorrhea_Specimen_Collection_Date', date);
                                handleFormFieldChange(e);
                              }}
                              onBlur={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setSelectedClient({
                                  ...selectedClient,
                                  gonorrhea_Specimen_Collection_Date: date,
                                });
                                setValue('gonorrhea_Specimen_Collection_Date', date);
                              }}
                              min={minDate}
                              max={maxDate}
                              //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                              //disabled={!isEditable && !updatedEditable}
                              disabled={type === "Updated" || type === "View" || !selectedClient.gonorrhea_Type}
                            />
                            <div className="error m-0">
                              {updateCaseReportValidationErrors.gonorrhea_Specimen_Collection_Date}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="gonorrheaSpecimenID"
                              type="text"
                              value={selectedClient.gonorrhea_Specimen_ID}
                              onChange={(e) => setSelectedClient({ ...selectedClient, gonorrhea_Specimen_ID: e.target.value })}
                              //disabled={isAdmin ? !isAdmin : !isEditable}
                              //disabled={!isEditable && !updatedEditable}
                              disabled={type === "Updated" || type === "View" || !selectedClient.gonorrhea_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {updateCaseReportValidationErrors.gonorrheaSpecimenID}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={selectedClient.gonorrhea_Type !== null && selectedClient.gonorrhea_Type !== ''}
                            />
                            <Form.Select
                              {...register('gonorrhea_Result')}
                              name="gonorrhea_Result"
                              value={selectedClient.gonorrhea_Result || ""}
                              onChange={(e) => {
                                setSelectedClient({
                                  ...selectedClient,
                                  gonorrhea_Result: e.target.value,
                                });
                                handleFormFieldChange(e);
                              }
                              }
                              //disabled={isAdmin ? !isAdmin : !isEditable}
                              //disabled={!isEditable && !updatedEditable}
                              disabled={type === "Updated" || type === "View" || !selectedClient.gonorrhea_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {
                                updateCaseReportValidationErrors.gonorrhea_Result
                              }
                            </div>
                          </Col>
                        </Row>
                      )}
                    </AppCard>
                  )
                }
                {/* STD Info Updated */}
                <Form.Control
                  {...register('showStdTestInfo')}
                  type="hidden"
                  value={
                    (type !== "" && selectedClient?.sourceName !== "FLCareLookUp" && !showStdTestInfo)
                      ? "true"
                      : "false"
                  }
                />
                {type !== "" && (selectedClient?.sourceName != "FLCareLookUp") && !showStdTestInfo && (
                  <div>
                    {/* Disableed section for DW Client - Will have the STD details that were fetched from DW earlier */}
                    <AppCard title={
                      <div className="w-100" id="STDTestInformation">
                        <div className="section-header">
                          <span className="section-title">
                            STD Test Information
                          </span>

        <span
          onClick={toggleStd}
          className="section-toggle"
        >
          {isStdCollapsed ? "+" : "−"}
        </span>
      </div>
    </div>
  } bottomMargin>
    {!isStdCollapsed && (
      <Card.Body>
        {stdTestInformationGroups.map((group) => (
          <section key={group.testName} className="mb-4">
            <AppLabel
              label={group.testName}
              style={{
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            />
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped mb-0"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "25%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>Specimen Collection Date</th>
                    <th>Specimen ID</th>
                    <th>Details</th>
                    <th>Titer</th>
                  </tr>
                </thead>
                <tbody>
                  {group.rows.length > 0 ? (
                    group.rows.map((row, index) => 
                      row.specimenDate ? (
                      <tr
                        key={`${group.testName}-${row.historyNumber ?? "current"}-${index}`}
                      >
                        <td>{formatStdTableDate(row.specimenDate)}</td>
                        <td>{row.specimenId ?? ""}</td>
                        <td>{row.details ?? ""}</td>
                        <td>{row.titer ?? ""}</td>
                      </tr>
                      ) : null
                    )
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No test information found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        ))}
      </Card.Body>
    )}
    {false && (
                          <Card.Body>
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px"
                              }} label={"RPR Test Information"} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('rprCollectionDate')}
                                  type="date"
                                  name="dateTest"
                                  value={
                                    selectedClient.rpR_Specimen_Collection_Date
                                      ? new Date(selectedClient.rpR_Specimen_Collection_Date)
                                        .toISOString()
                                        .split("T")[0]
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      rpR_Specimen_Collection_Date: date
                                    })
                                    setValue('rprCollectionDate', date)
                                  }}
                                  onBlur={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setSelectedClient({
                                      ...selectedClient,
                                      rpR_Specimen_Collection_Date: date,
                                    });
                                    setValue('rprCollectionDate', date)
                                  }}
                                  max={maxDate}
                                  min={minDate}
                                  //disabled={(isAdmin ? !isAdmin : !isEditable || isChecked) && !isHivProvider}
                                  //disabled={!isEditable && !updatedEditable}
                                  disabled={type === "Updated" || type === "View"}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.rprCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="rprSpecimenID"
                                  type="text"
                                  value={selectedClient.rpR_Specimen_ID}
                                  onChange={(e) => setSelectedClient({ ...selectedClient, rpR_Specimen_ID: e.target.value })}
                                  //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                                  //disabled={!isEditable && !updatedEditable}
                                  disabled={type === "Updated" || type === "View"}
                                />
                                <div className="error m-0">
                                  {updateCaseReportValidationErrors.rprSpecimenID}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                //  required={selectedClient.rpR_Specimen_Collection_Date !== null && selectedClient.rpR_Specimen_Collection_Date !== ""}
                                />
                                <Form.Select
                                  value={selectedClient.rpR_Details || ""}
                                  onChange={(e) =>
                                    setSelectedClient({
                                      ...selectedClient,
                                      rpR_Details: e.target.value,
                                    })
                                  }
                                  //disabled={isAdmin ? !isAdmin : !isEditable}
                                  //disabled={!isEditable && !updatedEditable}
                                  disabled={type === "Updated" || type === "View"}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive">Positive (Reactive)</option>
                                  <option value="Negative">Negative (Non-Reactive)</option>
                                </Form.Select>
                              </Col>
                              <Col>
                                <AppLabel label={"Titer"} />
                                <Form.Control
                                  type="text"
                                  value={selectedClient.rpR_Titer}
                                  //disabled={isAdmin ? !isAdmin : !isEditable}
                                  //disabled={!isEditable && !updatedEditable}
                                  disabled={type === "Updated" || type === "View"}
                                  onChange={(e) => setSelectedClient({ ...selectedClient, rpR_Titer: e.target.value })}
                                  maxLength={10}
                                />
                              </Col>
                              {historicalRPR.length > 0 && (
  <div style={{ marginTop: "15px" }}>
    <AppLabel label="Historical RPR Results" style={{ fontWeight: "bold" }} />

                                {historicalRPR.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"CSF-VDRL Test Information"}
                            />
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register('vdrlCollectionDate')}
                                type="date"
                                name="dateTest"
                                value={
                                  selectedClient.vdrL_Specimen_Collection_Date
                                    ? new Date(selectedClient.vdrL_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    vdrL_Specimen_Collection_Date: date
                                  });
                                  setValue('vdrlCollectionDate', date)
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    vdrL_Specimen_Collection_Date: date,
                                  });
                                  setValue('vdrlCollectionDate', date)
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.vdrlCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="vdrlSpecimenID"
                                type="text"
                                value={selectedClient.vdrL_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, vdrL_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.vdrlSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                              // required={selectedClient.vdrL_Specimen_Collection_Date !== null && selectedClient.vdrL_Specimen_Collection_Date !== ""}
                              />
                              <Form.Select
                                value={selectedClient.vdrL_Details || ""}
                                name="vdrL_Details"
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    vdrL_Details: e.target.value,
                                  })
                                }
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive (Reactive)</option>
                                <option value="Negative">Negative (Non-Reactive)</option>
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Titer"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.vdrL_Titer}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                                onChange={(e) => setSelectedClient({ ...selectedClient, vdrL_Titer: e.target.value })}
                                maxLength={10}
                              />
                            </Col>
                            {historicalVDRL.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical VDRL Results" style={{ fontWeight: "bold" }} />

                                {historicalVDRL.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"TP-PA Information"} />
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register('tppaCollectionDate')}
                                type="date"
                                name="dateTest"
                                value={
                                  selectedClient.tppA_Specimen_Collection_Date
                                    ? new Date(selectedClient.tppA_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Specimen_Collection_Date: date
                                  })
                                  setValue('tppaCollectionDate', date);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Specimen_Collection_Date: date,
                                  });
                                  setValue('tppaCollectionDate', date);
                                }}
                                min={minDate}
                                max={maxDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.tppaCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="tppaSpecimenID"
                                type="text"
                                value={selectedClient.tppA_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, tppA_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.tppaSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                              //  required={selectedClient.tppA_Specimen_Collection_Date !== null && selectedClient.tppA_Specimen_Collection_Date !== ""}
                              />
                              <Form.Select
                                value={selectedClient.tppA_Details || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    tppA_Details: e.target.value,
                                  })
                                }
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                              </Form.Select>
                            </Col>
                            {historicalTPPA.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical TP-PA Results" style={{ fontWeight: "bold" }} />

                                {historicalTPPA.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}
                          </Row>
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"FTA-ABS Information "} />
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register('ftaabsCollectionDate')}
                                type="date"
                                name="dateTest"
                                value={
                                  selectedClient.ftA_ABS_Specimen_Collection_Date
                                    ? new Date(selectedClient.ftA_ABS_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftA_ABS_Specimen_Collection_Date: e.target.value,
                                  })
                                  setValue('ftaabsCollectionDate', date);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftA_ABS_Specimen_Collection_Date: date,
                                  });
                                  setValue('ftaabsCollectionDate', date);
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.ftaabsCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="ftaABSSpecimenID"
                                type="text"
                                value={selectedClient.ftA_ABS_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, ftA_ABS_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.ftaabsSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                              // required={selectedClient.ftA_ABS_Specimen_Collection_Date !== null && selectedClient.ftA_ABS_Specimen_Collection_Date !== ""}
                              />
                              <Form.Select
                                value={selectedClient.ftA_ABS_Details || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    ftA_ABS_Details: e.target.value,
                                  })
                                }
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                              </Form.Select>
                            </Col>
                            {historicalFTAABS.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical FTA-ABS Results" style={{ fontWeight: "bold" }} />

                                {historicalFTAABS.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}
                          </Row>
                          <Row className="mb-3">
                            <AppLabel
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }}
                              label={"EIA Information"}
                            />

                            {/* SPECIMEN COLLECTION DATE */}
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register("eIAIgGSpecimenCollectionDate")}
                                type="date"
                                name="eIAIgGSpecimenCollectionDate"
                                value={
                                  selectedClient.eiA_IgG_Specimen_Collection_Date
                                    ? new Date(selectedClient.eiA_IgG_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(e.target.value, maxDate);

                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_Collection_Date: date,
                                  });

                                  setValue("eIAIgGSpecimenCollectionDate", date);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(e.target.value, maxDate);

                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_Collection_Date: date,
                                  });

                                  setValue("eIAIgGSpecimenCollectionDate", date);
                                }}
                                max={maxDate}
                                min={minDate}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgGSpecimenCollectionDate}
                              </div>
                            </Col>

                            {/* SPECIMEN ID */}
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="eIAIgGSpecimenID"
                                type="text"
                                value={selectedClient.eiA_IgG_Specimen_ID || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Specimen_ID: e.target.value,
                                  })
                                }
                                disabled={type === "Updated" || type === "View"}
                                maxLength={15}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgGSpecimenId}
                              </div>
                            </Col>

                            {/* DETAILS */}
                            <Col>
                              <AppLabel label={"Details"} />

                              <Form.Select
                                value={selectedClient.eiA_IgG_Details || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    eiA_IgG_Details: e.target.value,
                                  })
                                }
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Reactive</option>
                                <option value="Negative">Non-Reactive</option>
                              </Form.Select>

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.eIAIgG_Result}
                              </div>
                            </Col>
                            {historicalEIA.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical EIA Results" style={{ fontWeight: "bold" }} />

                                {historicalEIA.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}
                          </Row>

                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"Chlamydia [200] Test Information "} />
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register('chlamydiaCollectionDate')}
                                type="date"
                                name="dateTest"
                                value={
                                  selectedClient.chlamydiaDate
                                    ? new Date(selectedClient.chlamydiaDate)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydiaDate: date
                                  })
                                  setValue('chlamydiaCollectionDate', date)
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydiaDate: date,
                                  });
                                  setValue('chlamydiaCollectionDate', date)
                                }}
                                max={maxDate}
                                min={minDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.chlamydiaCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="chlamydiaSpecimenID"
                                type="text"
                                value={selectedClient.chlamydia_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, chlamydia_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.chlamydiaSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                              // required={selectedClient.chlamydiaDate !== null && selectedClient.chlamydiaDate !== ""}
                              />
                              <Form.Select
                                name="hospitalLocation"
                                value={selectedClient.chlamydia_Details || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    chlamydia_Details: e.target.value,
                                  })
                                }
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                              </Form.Select>
                            </Col>
                            {historicalChlamydia.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical Chlamydia Results" style={{ fontWeight: "bold" }} />

                                {historicalChlamydia.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

        <Col>
          <AppLabel label="Titer" />
          <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
        </Col>
      </Row>
    ))}
  </div>
)}
                            </Row>
                          </Card.Body>
    )}
    {false && (
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"Gonorrhea [300] Test Information "} />
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} />
                              <Form.Control
                                {...register('gonorrheaCollectionDate')}
                                type="date"
                                name="dateTest"
                                value={
                                  selectedClient.gonorrhea_Specimen_Collection_Date
                                    ? new Date(selectedClient.gonorrhea_Specimen_Collection_Date)
                                      .toISOString()
                                      .split("T")[0]
                                    : ""
                                }
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    gonorrhea_Specimen_Collection_Date: date
                                  })
                                  setValue('gonorrheaCollectionDate', date);
                                }}
                                onBlur={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setSelectedClient({
                                    ...selectedClient,
                                    gonorrhea_Specimen_Collection_Date: date,
                                  });
                                  setValue('gonorrheaCollectionDate', date);
                                }}
                                min={minDate}
                                max={maxDate}
                                //disabled={isAdmin ? !isAdmin : !isEditable || isChecked}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.gonorrheaCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="gonorrheaSpecimenID"
                                type="text"
                                value={selectedClient.gonorrhea_Specimen_ID}
                                onChange={(e) => setSelectedClient({ ...selectedClient, gonorrhea_Specimen_ID: e.target.value })}
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.gonorrheaSpecimenID}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                               // required={selectedClient.gonorrhea_Specimen_Collection_Date !== null && selectedClient.gonorrhea_Specimen_Collection_Date !== ''}
                              />
                              <Form.Select
                                name="hospitalLocation"
                                value={selectedClient.gonorrhea_Details || ""}
                                onChange={(e) =>
                                  setSelectedClient({
                                    ...selectedClient,
                                    gonorrhea_Details: e.target.value,
                                  })
                                }
                                //disabled={isAdmin ? !isAdmin : !isEditable}
                                //disabled={!isEditable && !updatedEditable}
                                disabled={type === "Updated" || type === "View"}
                              >
                                <option value="0">--</option>
                                <option value="Positive">Positive</option>
                                <option value="Negative">Negative</option>
                              </Form.Select>
                            </Col>
                            {historicalGonorrhea.length > 0 && (
  <div style={{ marginTop: "15px" }}>
    <AppLabel label="Historical Gonorrhea Results" style={{ fontWeight: "bold" }} />

                              {historicalGonorrhea.map((row, index) => (
                                <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                  <Col>
                                    <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                    <Form.Control
                                      type="date"
                                      value={convertToISODate(row.testSpecimenDate)}
                                      disabled
                                    />
                                  </Col>

                                  <Col>
                                    <AppLabel label="Specimen ID" />
                                    <Form.Control type="text" value={row.specimenId || ""} disabled />
                                  </Col>

                                  <Col>
                                    <AppLabel label="Details" />
                                    <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                  </Col>

                                  <Col>
                                    <AppLabel label="Titer" />
                                    <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                  </Col>
                                </Row>
                              ))}
                            </div>
                          )}
                        </Row>)}
                    </AppCard>

                    <AppCard title={
                      <div className="w-100" id="SyphilisTreatmentInformation">
                        <div className="section-header">
                          <span className="section-title">
                            STD Treatment History
                          </span>

                          <span
                            onClick={toggleSyphilisTreatment}
                            className="section-toggle"
                          >
                            {isSyphilisTreatmentCollapsed ? "+" : "-"}
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      {!isSyphilisTreatmentCollapsed && (
                        <Card.Body>
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped mb-0">
                              <thead>
                                <tr>
                                  <th>Added Date</th>
                                  <th>Provider Name</th>
                                  <th>Screening Date</th>
                                  <th>Exam Date</th>
                                  <th>Treatment Date</th>
                                  <th>Treatment Name</th>
                                  <th>Treatment Administered By</th>
                                </tr>
                              </thead>
                              <tbody>
                                {syphilisTreatmentHistory.length > 0 ? (
                                  syphilisTreatmentHistory.map((row, index) => (
                                    <tr key={`${row.source ?? "treatment"}-${row.treatmentHistoryRowNum ?? index}`}>
                                      <td>{formatDisplayDate(row.starsAddedDate)}</td>
                                      <td>{row.providerName ?? ""}</td>
                                      <td>{formatDisplayDate(row.screeningDate)}</td>
                                      <td>{formatDisplayDate(row.examDate)}</td>
                                      <td>{formatDisplayDate(row.treatedDate)}</td>
                                      <td>{row.treatmentData ?? ""}</td>
                                      <td>{row.treatmentAdministeredName ?? ""}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      No treatment history found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </Card.Body>
                      )}
                    </AppCard>

                    <AppCard title={
                      <div className="w-100" id="UpdatedSTDTestInformation">
                        <div className="section-header">
                          <span className="section-title">
                            Updated STD Test Information
                          </span>

                          <span
                            onClick={toggleUpdatedStd}
                            className="section-toggle"
                          >
                            {isUpdatedStdCollapsed ? "+" : "−"}
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      {!isUpdatedStdCollapsed && (
                        <Card.Body>
                          {/* RPR */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px"
                            }} label={"RPR Test Information"} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />

                              <Form.Select
                                {...register('UpdatedRprType')}
                                name="UpdatedRprType"
                                value={selectedClient.updatedRPR_Type}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedRPR_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedRprSpecimenCollectionDate: any; updatedRprSpecimenId: any; updatedRPR_Result: any; updatedRprTiter: any; }) => ({
                                    ...prev,
                                    updatedRPR_Type: newType,
                                    updatedRprSpecimenCollectionDate: newType ? prev.updatedRprSpecimenCollectionDate : "", // Clear date if type empty
                                    updatedRPR_Result: newType ? prev.updatedRPR_Result : "", // Clear result if type empty
                                    updatedRprSpecimenId: newType ? prev.updatedRprSpecimenId : "",
                                    updatedRprTiter: newType ? prev.updatedRprTiter : "",
                                  }));
                                  if (!newType) { setValue("UpdatedRprSpecimenCollectionDate", "", { shouldValidate: true }); setValue("UpdatedRprDetails", "", { shouldValidate: true }); }
                                }}
                                disabled={!isEditable && !updatedEditable}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'RPR')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedRprType}
                              </div>


                              {/* {selectedClient.updatedRprType && selectedClient.updatedRprType != "" && selectedClient.updatedRprType !== "Quantitative RPR" && selectedClient.updatedRprType !== "Qualitative RPR" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedRprType1')}
                                      type="text"
                                      value={selectedClient.updatedRprType == "Other" ? "" : selectedClient.updatedRprType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedRprType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedRprType1}
                                    </div>
                                  </div>
                                )} */}


                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedRPR_Type != ""} />

                              <Form.Control
                                {...register('UpdatedRprSpecimenCollectionDate')}
                                name="UpdatedRprSpecimenCollectionDate"
                                type="date"
                                // FIX: Properly format the ISO string for the HTML date input (already done, just keeping it)
                                value={selectedClient.updatedRprSpecimenCollectionDate ?
                                  selectedClient.updatedRprSpecimenCollectionDate.split('T')[0] :
                                  ''}
                                // IMPROVEMENT: Simplified readOnly logic

                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedRPR_Type}
                                onChange={(e) => {

                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedRprSpecimenCollectionDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate}
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedRprSpecimenCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedRprSpecimenId"
                                type="text"
                                value={selectedClient.updatedRprSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedRPR_Type}

                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedRprSpecimenId: e.target.value,
                                  }));
                                }}
                              />

                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedRPR_Type != ""}
                              />

                              <Form.Select
                                {...register('UpdatedRprDetails')}
                                name="UpdatedRprDetails"
                                value={selectedClient.updatedRPR_Result}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedRPR_Type}
                                onChange={(e) => {
                                  const newResult = e.target.value;
                                  const shouldClearTiter = newResult === "" || newResult === "6"; // "6" is Non-Reactive
                                  setSelectedClient((prev: { updatedRprTiter: any; }) => ({
                                    ...prev,
                                    updatedRPR_Result: newResult,
                                    updatedRprTiter: shouldClearTiter ? "" : prev.updatedRprTiter,
                                  }));
                                  handleFormFieldChange(e);

                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedRprDetails}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Titer"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.updatedRprTiter}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.updatedRPR_Result !== '5'}
                                maxLength={10}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedRprTiter: e.target.value,
                                  }));
                                }}

                              />
                            </Col>
                          </Row>
                          {/* VDRL */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"CSF-VDRL Test Information"} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />

                              <Form.Select
                                {...register('UpdatedVdrlType')}
                                name="UpdatedVdrlType"
                                value={selectedClient.updatedVDRL_Type}
                                disabled={!isEditable && !updatedEditable}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedVDRL_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedVdrlSpecimenCollectionDate: any; updatedVdrlSpecimenId: any; updatedVDRL_Result: any; updatedVdrlTiter: any; }) => ({
                                    ...prev,
                                    updatedVDRL_Type: newType,
                                    updatedVdrlSpecimenCollectionDate: newType ? prev.updatedVdrlSpecimenCollectionDate : "", // Clear date if type empty
                                    updatedVDRL_Result: newType ? prev.updatedVDRL_Result : "", // Clear result if type empty
                                    updatedVdrlSpecimenId: newType ? prev.updatedVdrlSpecimenId : "",
                                    updatedVdrlTiter: newType ? prev.updatedVdrlTiter : "",
                                  }));
                                  if (!newType) { setValue("UpdatedVdrlSpecimenCollectionDate", "", { shouldValidate: true }); setValue("UpdatedVdrlDetails", "", { shouldValidate: true }); }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'VDRL')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedVdrlType}
                              </div>
                              {/* {selectedClient.updatedVdrlType && selectedClient.updatedVdrlType !== "" && selectedClient.updatedVdrlType !== "VDRL" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedVdrlType1')}
                                      type="text"
                                      value={selectedClient.updatedVdrlType == "Other" ? "" : selectedClient.updatedVdrlType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedVdrlType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedVdrlType1}
                                    </div>
                                  </div>
                                )} */}
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedVDRL_Type != ""} />
                              <Form.Control
                                {...register('UpdatedVdrlSpecimenCollectionDate')}
                                name="UpdatedVdrlSpecimenCollectionDate"
                                type="date"
                                value={selectedClient.updatedVdrlSpecimenCollectionDate ?
                                  selectedClient.updatedVdrlSpecimenCollectionDate.split('T')[0] :
                                  ''}

                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedVDRL_Type}
                                onChange={(e) => {

                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedVdrlSpecimenCollectionDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedVdrlSpecimenCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedVdrlSpecimenId"
                                type="text"
                                value={selectedClient.updatedVdrlSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedVDRL_Type}

                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedVdrlSpecimenId: e.target.value,
                                  }));
                                }}
                              />
                              <div className="error m-0">
                                {
                                  clientInfoValidationErrors.vdrlSpecimenID
                                }
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedVDRL_Type != ""}
                              />

                              <Form.Select
                                {...register('UpdatedVdrlDetails')}
                                name="UpdatedVdrlDetails"
                                value={selectedClient.updatedVDRL_Result}
                                onChange={(e) => {
                                  const newResult = e.target.value;
                                  const shouldClearTiter = newResult === "" || newResult === "6"; // "6" is Non-Reactive
                                  setSelectedClient((prev: { updatedVdrlTiter: any; }) => ({
                                    ...prev,
                                    updatedVDRL_Result: newResult,
                                    updatedVdrlTiter: shouldClearTiter ? "" : prev.updatedVdrlTiter,
                                  }));
                                  handleFormFieldChange(e);

                                }}

                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedVDRL_Type}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedVdrlDetails}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Titer"} />
                              <Form.Control
                                type="text"
                                value={selectedClient.updatedVdrlTiter}
                                disabled={(!isEditable && !updatedEditable) || selectedClient.updatedVDRL_Result !== '5'}
                                maxLength={10}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedVdrlTiter: e.target.value,
                                  }));
                                }}

                              />
                            </Col>
                          </Row>
                          {/* TP-PA */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"TP-PA Information"} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />

                              <Form.Select
                                {...register('UpdatedTpPaType')}
                                name="UpdatedTpPaType"
                                value={selectedClient.updatedTPPA_Type}
                                disabled={!isEditable && !updatedEditable}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedTPPA_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedTpPaSpecimenCollectionDate: any; updatedTpPaSpecimenId: any; updatedTPPA_Result: any; }) => ({
                                    ...prev,
                                    updatedTPPA_Type: newType,
                                    updatedTpPaSpecimenCollectionDate: newType ? prev.updatedTpPaSpecimenCollectionDate : "", // Clear date if type empty
                                    updatedTpPaSpecimenId: newType ? prev.updatedTpPaSpecimenId : "", // Clear result if type empty
                                    updatedTPPA_Result: newType ? prev.updatedTPPA_Result : "",
                                  }));
                                  if (!newType) { setValue("UpdatedTpPaSpecimenCollectionDate", "", { shouldValidate: true }); setValue("UpdatedTpPaDetails", "", { shouldValidate: true }); }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'TP-PA')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedTpPaType}
                              </div>
                              {/* {selectedClient.updatedTpPaType && selectedClient.updatedTpPaType !== "" && selectedClient.updatedTpPaType !== "TP-PA" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedTpPaType1')}
                                      type="text"
                                      value={selectedClient.updatedTpPaType == "Other" ? "" : selectedClient.updatedTpPaType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedTpPaType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedTpPaType1}
                                    </div>
                                  </div>
                                )} */}
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedTPPA_Type != ""} />
                              <Form.Control
                                {...register('UpdatedTpPaSpecimenCollectionDate')}
                                name="UpdatedTpPaSpecimenCollectionDate"
                                type="date"
                                value={selectedClient.updatedTpPaSpecimenCollectionDate ?
                                  selectedClient.updatedTpPaSpecimenCollectionDate.split('T')[0] :
                                  ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedTPPA_Type}

                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedTpPaSpecimenCollectionDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedTpPaSpecimenCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedTpPaSpecimenId"
                                type="text"
                                value={selectedClient.updatedTpPaSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedTPPA_Type}
                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedTpPaSpecimenId: e.target.value,
                                  }));
                                }}

                              />
                              <div className="error m-0">
                                {
                                  clientInfoValidationErrors.tppaSpecimenID
                                }
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedTPPA_Type != ""}
                              />

                              <Form.Select
                                {...register('UpdatedTpPaDetails')}
                                name="UpdatedTpPaDetails"
                                value={selectedClient.updatedTPPA_Result}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedTPPA_Type}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedTPPA_Result: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedTpPaDetails}
                              </div>
                            </Col>
                          </Row>
                          {/* FTA-ABS */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"FTA-ABS Information "} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />

                              <Form.Select
                                {...register('UpdatedFtaAbsType')}
                                name="UpdatedFtaAbsType"
                                value={selectedClient.updatedFTAABS_Type}
                                disabled={!isEditable && !updatedEditable}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedFTAABS_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedFtaAbsSpecimenCollectionDate: any; updatedFtaAbsSpecimenId: any; updatedFTAABS_Result: any; }) => ({
                                    ...prev,
                                    updatedFTAABS_Type: newType,
                                    updatedFtaAbsSpecimenCollectionDate: newType ? prev.updatedFtaAbsSpecimenCollectionDate : "", // Clear date if type empty
                                    updatedFtaAbsSpecimenId: newType ? prev.updatedFtaAbsSpecimenId : "", // Clear result if type empty
                                    updatedFTAABS_Result: newType ? prev.updatedFTAABS_Result : "",
                                  }));
                                  if (!newType) { setValue("UpdatedFtaAbsSpecimenCollectionDate", "", { shouldValidate: true }); setValue("UpdatedFtaAbsDetails", "", { shouldValidate: true }); }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'FTA-ABS')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedFtaAbsType}
                              </div>
                              {/* {selectedClient.updatedFtaAbsType && selectedClient.updatedFtaAbsType !== "" && selectedClient.updatedFtaAbsType !== "FTA-ABS" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedFtaAbsType1')}
                                      type="text"
                                      value={selectedClient.updatedFtaAbsType == "Other" ? "" : selectedClient.updatedFtaAbsType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedFtaAbsType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedFtaAbsType1}
                                    </div>
                                  </div>
                                )} */}
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedFTAABS_Type != ""} />
                              <Form.Control
                                {...register('UpdatedFtaAbsSpecimenCollectionDate')}
                                name="UpdatedFtaAbsSpecimenCollectionDate"
                                type="date"
                                value={selectedClient.updatedFtaAbsSpecimenCollectionDate ?
                                  selectedClient.updatedFtaAbsSpecimenCollectionDate.split('T')[0] :
                                  ''}

                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedFTAABS_Type}
                                onChange={(e) => {

                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedFtaAbsSpecimenCollectionDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedFtaAbsSpecimenCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedFtaAbsSpecimenId"
                                type="text"
                                value={selectedClient.updatedFtaAbsSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedFTAABS_Type}
                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedFtaAbsSpecimenId: e.target.value,
                                  }));
                                }}

                              />
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedFTAABS_Type != ""}
                              />

                              <Form.Select
                                {...register('UpdatedFtaAbsDetails')}
                                name="UpdatedFtaAbsDetails"
                                value={selectedClient.updatedFTAABS_Result}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedFTAABS_Type}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedFTAABS_Result: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedFtaAbsDetails}
                              </div>
                            </Col>
                          </Row>
                          {/* EIA */}
                          <Row className="mb-3">
                            <AppLabel
                              style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }}
                              label={"EIA Information"}
                            />

                            {/* TYPE */}
                            <Col>
                              <AppLabel label={"Type"} />

                              <Form.Select
                                {...register("UpdatedEiaType")}
                                name="UpdatedEiaType"
                                value={selectedClient.updatedEIA_Type}
                                disabled={!isEditable && !updatedEditable}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: any) => ({
                                    ...prev,
                                    updatedEIA_Type: newType,
                                    updatedEiaDate: newType ? prev.updatedEiaDate : "",
                                    updatedEIASpecimenId: newType ? prev.updatedEIASpecimenId : "",
                                    updatedEIA_Result: newType ? prev.updatedEIA_Result : ""
                                  }));

                                  if (!newType) {
                                    setValue("UpdatedEiaDate", "", { shouldValidate: true });
                                    setValue("UpdatedEiaDetails", "", { shouldValidate: true });
                                  }

                                  handleFormFieldChange(e);
                                }}
                              >

                                <option value="">Select Test Type</option>
                                {caseReportTestData
                                  .filter((option) => option.value === "EIA")
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedEiaType}
                              </div>
                            </Col>

                            {/* SPECIMEN COLLECTION DATE */}
                            <Col>
                              <AppLabel
                                label={"Specimen Collection Date"}
                                required={selectedClient.updatedEIA_Type !== ""}
                              />

                              <Form.Control
                                {...register("UpdatedEiaDate")}
                                name="UpdatedEiaDate"
                                type="date"
                                value={
                                  selectedClient.updatedEiaDate
                                    ? selectedClient.updatedEiaDate.split("T")[0]
                                    : ""
                                }
                                disabled={
                                  (!isEditable && !updatedEditable) || !selectedClient.updatedEIA_Type
                                }
                                onChange={(e) => {
                                  setSelectedClient((prev: any) => ({
                                    ...prev,
                                    updatedEiaDate: e.target.value
                                  }));

                                  handleFormFieldChange(e);
                                }}
                                max={maxDate}
                                min={minDate}
                              />


                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedEiaDate}
                              </div>
                            </Col>

                            {/* SPECIMEN ID */}
                            <Col>
                              <AppLabel label={"Specimen ID"} />

                              <Form.Control
                                name="UpdatedEiaSpecimenId"
                                type="text"
                                value={selectedClient.updatedEIASpecimenId || ""}
                                disabled={
                                  (!isEditable && !updatedEditable) || !selectedClient.updatedEIA_Type
                                }
                                maxLength={15}
                                onChange={(e) => {
                                  setSelectedClient((prev: any) => ({
                                    ...prev,
                                    updatedEIASpecimenId: e.target.value
                                  }));
                                  setValue("UpdatedEiaSpecimenId", e.target.value, { shouldValidate: true });
                                  handleFormFieldChange(e);
                                }}
                              />

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedEiaSpecimenId}
                              </div>
                            </Col>

                            {/* DETAILS */}
                            <Col>
                              <AppLabel
                                label={"Details"}
                                required={selectedClient.updatedEIA_Type !== ""}
                              />

                              <Form.Select
                                {...register("UpdatedEiaDetails")}
                                name="UpdatedEiaDetails"
                                value={selectedClient.updatedEIA_Result}
                                disabled={
                                  (!isEditable && !updatedEditable) || !selectedClient.updatedEIA_Type
                                }
                                onChange={(e) => {
                                  setSelectedClient((prev: any) => ({
                                    ...prev,
                                    updatedEIA_Result: e.target.value
                                  }));

                                  handleFormFieldChange(e);
                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter(
                                    (option) =>
                                      option.value === "Reactive" || option.value === "Non-Reactive"
                                  )
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>

                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedEiaDetails}
                              </div>
                            </Col>
                          </Row>

                          {/* Chlamydia */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"Chlamydia [200] Test Information "} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />
                              <Form.Select
                                {...register('UpdatedChlamydiaType')}
                                name="UpdatedChlamydiaType"
                                value={selectedClient.updatedChlamydia_Type}
                                disabled={!isEditable && !updatedEditable}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedChlamydia_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedChlamydiaDate: any; updatedChlamydiaSpecimenId: any; updatedChlamydia_Result: any; }) => ({
                                    ...prev,
                                    updatedChlamydia_Type: newType,
                                    updatedChlamydiaDate: newType ? prev.updatedChlamydiaDate : "", // Clear date if type empty
                                    updatedChlamydiaSpecimenId: newType ? prev.updatedChlamydiaSpecimenId : "", // Clear result if type empty
                                    updatedChlamydia_Result: newType ? prev.updatedChlamydia_Result : "",
                                  }));
                                  if (!newType) { setValue("UpdatedChlamydiaDate", "", { shouldValidate: true }); setValue("UpdatedChlamydiaDetails", "", { shouldValidate: true }); }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'Chlamydia')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedChlamydiaType}
                              </div>
                              {/* {selectedClient.updatedChlamydiaType && selectedClient.updatedChlamydiaType !== "" && selectedClient.updatedChlamydiaType !== "DNA" && selectedClient.updatedChlamydiaType !== "RNA" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedChlamydiaType1')}
                                      type="text"
                                      value={selectedClient.updatedChlamydiaType == "Other" ? "" : selectedClient.updatedChlamydiaType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedChlamydiaType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedChlamydiaType1}
                                    </div>
                                  </div>
                                )} */}
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedChlamydia_Type != ""} />
                              <Form.Control
                                {...register('UpdatedChlamydiaDate')}
                                name="UpdatedChlamydiaDate"
                                type="date"
                                value={selectedClient.updatedChlamydiaDate ?
                                  selectedClient.updatedChlamydiaDate.split('T')[0] :
                                  ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedChlamydia_Type}
                                onChange={(e) => {

                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedChlamydiaDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedChlamydiaDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedChlamydiaSpecimenId"
                                type="text"
                                value={selectedClient.updatedChlamydiaSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedChlamydia_Type}
                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedChlamydiaSpecimenId: e.target.value,
                                  }));
                                }}
                              />
                              <div className="error m-0">
                                {
                                  clientInfoValidationErrors.chlamydiaSpecimenID
                                }
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedChlamydia_Type != ""}
                              />
                              <Form.Select
                                {...register('UpdatedChlamydiaDetails')}
                                name="UpdatedChlamydiaDetails"
                                value={selectedClient.updatedChlamydia_Result}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedChlamydia_Type}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedChlamydia_Result: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedChlamydiaDetails}
                              </div>
                            </Col>
                          </Row>
                          {/* Gonorrhea */}
                          <Row className="mb-3">
                            <AppLabel style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }} label={"Gonorrhea [300] Test Information "} />
                            <Col>
                              <AppLabel
                                label={
                                  "Type"
                                }
                              />
                              <Form.Select
                                {...register('UpdatedGonorrheaType')}
                                name="UpdatedGonorrheaType"
                                value={selectedClient.updatedGonorrhea_Type}
                                disabled={!isEditable && !updatedEditable}
                                // onChange={(e) => {
                                //   setSelectedClient((prevClient: any) => ({
                                //     ...prevClient,
                                //     updatedGonorrhea_Type: e.target.value,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  const newType = e.target.value;

                                  setSelectedClient((prev: { updatedGonorrheaSpecimenCollectionDate: any; updatedGonorrheaSpecimenId: any; updatedGonorrhea_Result: any; }) => ({
                                    ...prev,
                                    updatedGonorrhea_Type: newType,
                                    updatedGonorrheaSpecimenCollectionDate: newType ? prev.updatedGonorrheaSpecimenCollectionDate : "", // Clear date if type empty
                                    updatedGonorrheaSpecimenId: newType ? prev.updatedGonorrheaSpecimenId : "", // Clear result if type empty
                                    updatedGonorrhea_Result: newType ? prev.updatedGonorrhea_Result : "",
                                  }));
                                  if (!newType) { setValue("UpdatedGonorrheaSpecimenCollectionDate", "", { shouldValidate: true }); setValue("UpdatedGonorrheaDetails", "", { shouldValidate: true }); }
                                }}
                              >
                                <option value="">Select Test Type</option> {/* Placeholder */}
                                {caseReportTestData
                                  .filter((option) => option.value === 'Gonorrhea')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value1}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedGonorrheaType}
                              </div>
                              {/* {selectedClient.updatedGonorrheaType && selectedClient.updatedGonorrheaType !== "DNA" && selectedClient.updatedGonorrheaType !== "RNA" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedGonorrheaType1')}
                                      type="text"
                                      value={selectedClient.updatedGonorrheaType == "Other" ? "" : selectedClient.updatedGonorrheaType || ""}
                                      disabled={!isEditable && !updatedEditable}
                                      onChange={(e) => {
                                        setSelectedClient((prevClient: any) => ({
                                          ...prevClient,
                                          updatedGonorrheaType: e.target.value,
                                        }));
                                      }}
                                    />
                                    <div className="error m-0">
                                      {updateCaseReportValidationErrors.UpdatedGonorrheaType1}
                                    </div>
                                  </div>
                                )} */}
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen Collection Date"} required={selectedClient.updatedGonorrhea_Type != ""} />
                              <Form.Control
                                {...register('UpdatedGonorrheaSpecimenCollectionDate')}
                                name="UpdatedGonorrheaSpecimenCollectionDate"
                                type="date"
                                value={selectedClient.updatedGonorrheaSpecimenCollectionDate ?
                                  selectedClient.updatedGonorrheaSpecimenCollectionDate.split('T')[0] :
                                  ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedGonorrhea_Type}
                                onChange={(e) => {

                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient, // <--- CORRECTED: Use prevClient here
                                    updatedGonorrheaSpecimenCollectionDate: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedGonorrheaSpecimenCollectionDate}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Specimen ID"} />
                              <Form.Control
                                name="UpdatedGonorrheaSpecimenId"
                                type="text"
                                value={selectedClient.updatedGonorrheaSpecimenId || ''}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedGonorrhea_Type}
                                maxLength={25}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedGonorrheaSpecimenId: e.target.value,
                                  }));
                                }}
                              />
                              <div className="error m-0">
                                {
                                  clientInfoValidationErrors.gonorrheaSpecimenID
                                }
                              </div>
                            </Col>
                            <Col>
                              <AppLabel
                                label={
                                  "Details"
                                }
                                required={selectedClient.updatedGonorrhea_Type != ""}
                              />
                              <Form.Select
                                {...register('UpdatedGonorrheaDetails')}
                                name="UpdatedGonorrheaDetails"
                                value={selectedClient.updatedGonorrhea_Result}
                                disabled={(!isEditable && !updatedEditable) || !selectedClient.updatedGonorrhea_Type}
                                onChange={(e) => {
                                  setSelectedClient((prevClient: any) => ({
                                    ...prevClient,
                                    updatedGonorrhea_Result: e.target.value,
                                  }));
                                  handleFormFieldChange(e);
                                }}
                              >
                                <option value="">--</option>
                                {caseReportResultData
                                  .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                  .map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                              </Form.Select>
                              <div className="error m-0">
                                {updateCaseReportValidationErrors.UpdatedGonorrheaDetails}
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      )}
                    </AppCard>

                  </div>
                )}



                {selectedClient.birthGenderName?.toLowerCase() == "female" && (
                  <AppCard title={
                    <div className="w-100" id="PregnancyInformation">
                      <div
                        className="section-header"
                      >
                        <span className="section-title">
                          Pregnancy Information
                        </span>
                      </div>
                    </div>
                  } bottomMargin>
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label="Pregnant" required />
                          <Form.Select
                            {...register("pregnantId")}
                            value={selectedClient.pregnantId || ""}
                            name="pregnant"
                            onChange={(e) => {
                              const value = e.target.value;


                              setSelectedClient({
                                ...selectedClient,
                                pregnantId: value,
                              });
                            }}
                            //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                            disabled={!isEditable && !updatedEditable}
                          >
                            <option value=""> -- </option> {/* Placeholder */}
                            {clientInfoStatusTypeData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                          <div className="error m-0">
                            {updateCaseReportValidationErrors.pregnantId}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"EDD"} />
                          <Form.Control

                            type="date"

                            value={selectedClient.edd?.split("T")[0]}
                            onChange={(e) => {
                              const date = adjustDateToMin(
                                e.target.value,
                                new Date().toISOString().split("T")[0]
                              );
                              setSelectedClient({
                                ...selectedClient,
                                edd: date,
                              })
                            }}
                            //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                            disabled={!isEditable && !updatedEditable}
                            min={new Date().toISOString().split("T")[0]}
                          />

                        </Col>
                        <Col>
                          <AppLabel label={"LMP Date"} required={selectedClient.pregnantId == "1"} />
                          <Form.Control
                            {...register("dateLmp")}
                            type="date"
                            name="dateLmp"
                            value={selectedClient?.dateLmp?.split("T")[0]}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setSelectedClient({
                                ...selectedClient,
                                dateLmp: date,
                              })
                              setValue('dateLmp', date);
                            }}
                            max={maxDate}
                            min={minDate}
                            //disabled={(isAdmin ? !isAdmin : !isEditable) && !isHivProvider}
                            disabled={!isEditable && !updatedEditable}
                          />
                          <div className="error m-0">
                            {updateCaseReportValidationErrors.dateLmp}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </AppCard>
                )}

                <AppCard title={
                  <div className="w-100" id="AdditionalNotes">
                    <div className="section-header">
                      <span className="section-title">
                        Additional Notes
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Row className="mb-3">
                    <Col>
                      <AppLabel style={{ fontWeight: "bold" }} label={"Treatment/Additional Notes"} />
                      {/* AdditionalNotes in DB */}
                      <Form.Control
                        as="textarea"
                        value={selectedClient.additionalNotes || ""}
                        onChange={(e) =>
                          setSelectedClient({
                            ...selectedClient,
                            additionalNotes: e.target.value,
                          })
                        }
                        disabled={!isEditable && !updatedEditable}
                        maxLength={1500}
                        rows={3}
                      />
                      <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                        Character Count: {selectedClient.additionalNotes ? selectedClient.additionalNotes.length : 0} / 1500
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <AppLabel style={{ fontWeight: "bold" }} label={"DOH Notes/Outcome"} />
                      {/* DOHNotes in DB */}
                      <Form.Control
                        as="textarea"
                        value={selectedClient.dohNotes || ""}
                        onChange={(e) =>
                          setSelectedClient({
                            ...selectedClient,
                            dohNotes: e.target.value,
                          })
                        }
                        disabled={!isEditable && !updatedEditable || !isAdmin}
                        maxLength={1500}
                        rows={3}
                      />
                      <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                        Character Count: {selectedClient.dohNotes ? selectedClient.dohNotes.length : 0} / 1500
                      </div>
                    </Col>
                  </Row>
                </AppCard>
                <Row className="mb-3 mt-7 justify-content-end">
                  <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row">
                    <Col className="text-end">
                      {(isEditable || updatedEditable) ? ( // Changed condition here
                        <AppButton
                          type="button"
                          variant="primary"
                          onClick={handleSave}
                          disabled={isSaving}
                        >
                          Save
                        </AppButton>
                      ) : (
                        ""
                      )}
                      <AppButton
                        type="button"
                        variant="secondary"
                        customClasses={['ms-3', 'me-2']}
                        onClick={() => {
                          setShowEditForm(false); // Close the form
                          setSelectedClient(null); // Reset selected client
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          }); // Bring focus back to the top
                        }}
                      >
                        Cancel
                      </AppButton>
                    </Col>
                  </div>
                </Row>
              </div>
            </div>
            {/* Floating sticky navigation */}
            {selectedClient && (
              <nav id="provider-sticky-nav" className="sticky-nav" aria-label="Section navigation">
                {!isNavCollapsed && navItems.map((item) => (
                  <a
                    key={item.id}
                    href={`#${item.id}`}
                    className="nav-btn"
                    onClick={(e) => handleNavItemClick(e, item.id)}
                  >
                    {item.label}
                  </a>
                ))}
              </nav>
            )}

            {/* Floating collapse/expand button */}
            {selectedClient && (
              <button
                ref={toggleRef}
                className={`nav-toggle provider-nav-toggle ${isNavCollapsed ? 'provider-nav-toggle--collapsed' : 'provider-nav-toggle--expanded'}`}

                onClick={handleNavToggle}
                aria-expanded={!isNavCollapsed}
                aria-label={isNavCollapsed ? "Expand navigation" : "Collapse navigation"}

                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = '#0051a2';
                  (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.1)';
                  (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = '#004e6a';
                  (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
                  (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
                }}
                title={isNavCollapsed ? 'Expand navigation' : 'Collapse navigation'}
              >
                {isNavCollapsed ? '◀' : '▶'}
              </button>
            )}

          </Container>
        )}
      </div>
    </>
  );
};

export default ProviderDashboard;
